// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:47.737Z
// Property: Pearl Point (ID: 6737460151191761)
// Collections: 36 amenities, 3 floorplans (live), 42 photos, 67 POIs, 21 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191761",
  "property_external_id": "5007362",
  "property_zillow_url": "https://www.zillow.com/homedetails/2400-Fm-2165-Rockport-TX-78382/250485871_zpid/",
  "property_apartments_url": "https://www.apartments.com/pearl-point-rockport-tx/r05ee71",
  "property_google_business_url": "https://www.google.com/maps/place/Pearl+Point/data=!4m2!3m1!1s0x0:0x67db2d5a2ef6761?sa=X&ved=2ahUKEwjiq_iuu7ySAxV2mSYFHeV6MCwQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "16832574881",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "pearl-point",
  "property_name": "Pearl Point",
  "property_website_url": "https://www.livepearlpoint.com/",
  "property_domain": "https://www.livepearlpoint.com/",
  "property_address": "2400 Fm 2165",
  "property_full_address": "2400 FM2165, Rockport, TX 78382",
  "property_address_1": "2400 FM2165",
  "property_address_2": null,
  "property_address_city": "Rockport",
  "property_address_state": "TX",
  "property_address_zip_full": "78382-4442",
  "property_address_zip": "78382",
  "property_address_country": "US",
  "property_address_county": "Aransas County",
  "property_neighborhood_address": "Rockport/North Aransas County",
  "property_address_latitude": "28.0566824",
  "property_address_longitude": "-97.0690363",
  "property_email": "pearlpoint@rrliving.com",
  "property_phone": "(361) 729-1200",
  "property_call_tracking_phone": "361-314-2716",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Experience the charm of Pearl Point in Rockport, TX, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans, complete with upscale amenities like a fitness center, pool, and pet-friendly spaces. Embrace a lifestyle of convenience and style—schedule your tour today!",
  "property_long_description": "Welcome to Pearl Point, your new home in beautiful Rockport, TX. Our vibrant apartment community features a variety of spacious floor plans, including one, two, and three-bedroom options to suit your lifestyle. Each unit is thoughtfully designed with modern amenities like air conditioning, stainless steel appliances, and granite countertops, ensuring a comfortable and stylish living experience. Enjoy private bathrooms, walk-in closets, and convenient in-unit washers and dryers, all within a smoke-free environment.\n\nAt Pearl Point, we pride ourselves on providing a wealth of amenities that elevate your everyday living. Enjoy the convenience of controlled access, on-site management, and a robust package service. Our pet-friendly community features a play area and pet washing station, making it an ideal sanctuary for you and your furry friends. Unwind in our tranquil courtyard, take a dip in the sparkling pool, or stay active in our state-of-the-art fitness center.\n\nOur clubhouse and business center offer the perfect blend of relaxation and productivity, with online services and high-speed internet access available throughout the property. Additional conveniences include door-to-door trash pickup, ample storage space, and a charming picnic area with grills for gatherings. \n\nWith options for furnished units and corporate suites available, along with features like vaulted ceilings and large balconies for enjoying spectacular views, Pearl Point is ready to meet your living needs. \n\nDon't wait to find your perfect home—browse our availability today or schedule a tour to experience all that Pearl Point has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-133e-70d0-b11b-0e2b32a74a59.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a seaside apartment complex with light blue buildings, a swimming pool, and surrounding landscaping.",
    "public_id": "019e6485-133e-70d0-b11b-0e2b32a74a59",
    "storage_key": "property/6737460151191761/019e6485-133e-70d0-b11b-0e2b32a74a59.webp",
    "width": 3072,
    "height": 1726
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "216",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.14814814814815",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$125\nApplication Fee\n$75",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Each apartment may have up to 3 pets, with a limit of 2 dogs per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://livepearlpoint.loftliving.com/login",
  "property_apply_now_url": "https://8896213.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-c2ab-7697-968f-5e8a32962dd7.webp",
  "property_primary_logo_media": {
    "alt_text": "The Residences at Pearl Point Rockport, Texas logo",
    "public_id": "019d076d-c2ab-7697-968f-5e8a32962dd7",
    "storage_key": "property/6737460151191761/019d076d-c2ab-7697-968f-5e8a32962dd7.webp",
    "width": 1449,
    "height": 366
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-c370-717d-8fa5-350aec70ae98.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Residences at Pearl Point logo",
    "public_id": "019d076d-c370-717d-8fa5-350aec70ae98",
    "storage_key": "property/6737460151191761/019d076d-c370-717d-8fa5-350aec70ae98.webp",
    "width": 1463,
    "height": 375
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595c-be38-70c7-ba9f-bb047cb26f71.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d595c-be38-70c7-ba9f-bb047cb26f71",
    "storage_key": "property/6737460151191761/019d595c-be38-70c7-ba9f-bb047cb26f71.webp",
    "width": 1280,
    "height": 323
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595c-b1f0-7338-bd92-72f5ea8d9d37.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d595c-b1f0-7338-bd92-72f5ea8d9d37",
    "storage_key": "property/6737460151191761/019d595c-b1f0-7338-bd92-72f5ea8d9d37.webp",
    "width": 1280,
    "height": 323
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#1b2356",
  "property_secondary_color": "#a8cfd6",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "760 - 1382",
  "property_sqft_min": "760",
  "property_sqft_max": "1382",
  "property_price_range": "1974",
  "property_price_min": null,
  "property_price_max": "1974",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/LIVEPearlPointRockportTX",
  "property_instagram_url": "https://www.instagram.com/pearl_point_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJI82uYCi1aYYRYWfvotWyfQY",
  "property_youtube_url": "https://www.youtube.com/watch?t=395&v=oC4vF26Zf54",
  "property_yelp_url": "https://www.yelp.com/biz/pearl-point-rockport",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pearl Point",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today  ",
  "property_home_amenities_blurb": "<p>Imagine living the dream encircled by beautiful beaches and bays with fabulous dining, shopping, and entertainment nearby! With easy access to the Highway 35 North Bypass, discover your new home here at Pearl Point <a href=\"/floor-plans/\">apartments</a> in Rockport, Texas!</p>",
  "property_home_floorplans_blurb": "<p>Pearl Point in Rockport, TX, offers a prime location near Coastal Bend, putting you close to everything you need. Centrally located in Rockport, our apartments are just minutes from local shopping, dining, and entertainment. With convenient freeway access, commuting around the area is quick and easy. Explore the nearby attractions highlighted on our map. At Pearl Point, everything you need is close to <a href=\"/floor-plans/\">home</a>.</p>",
  "property_home_gallery_blurb": "At Pearl Point in Rockport, TX, you won't just find a home—you'll discover a vibrant lifestyle. Choose from spacious one, two, or three-bedroom floor plans, each boasting luxurious amenities like a fitness center, pet play area, and inviting lounge. Picture yourself living here, surrounded by comfort and community!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Rockport, Pearl Point offers spacious one to three-bedroom apartments, surrounded by vibrant local culture and natural beauty. Enjoy quick access to enchanting spots like the Texas Maritime Museum, Rockport Beach Park, and the stunning Aransas National Wildlife Refuge, perfect for outdoor enthusiasts and art lovers alike.",
  "property_home_reviews_blurb": "Welcome to Pearl Point in Rockport, TX, where tranquil living meets resort-style amenities! Our residents rave about the \"lovely apartments\" and \"awesome\" staff, making it a true gem in the area. Discover why we’re celebrated for our pet-friendly atmosphere and beautiful surroundings—your peaceful retreat awaits!",
  "property_neighborhood_blurb": "<p>Pearl Point in Rockport, TX, offers a prime location near Coastal Bend, putting you close to everything you need. Centrally located in Rockport, our apartments are just minutes from local shopping, dining, and entertainment. With convenient freeway access, commuting around the area is quick and easy. Explore the nearby attractions highlighted on our map. At Pearl Point, everything you need is close to <a href=\"/floor-plans/\">home</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Embrace a lifestyle of comfort, quality, and style with <a href=\"/floor-plans/\">designer features in every home</a>! Your worries will fade as you relax in your spa-inspired soaking tub, available in select homes. Imagine basking in the sun and being refreshed by the cool waters lapping over you as you lounge in our resort-style pools. For a great start to your day, stop by our coffee cafe! Come and discover all the wonderful amenities at Pearl Point in Rockport, TX.</p>",
  "property_applynow_blurb": "At Pearl Point in Rockport, TX, stylish living meets modern convenience. Choose from spacious one-, two-, or three-bedroom apartments, featuring gourmet kitchens, private patios, and luxurious amenities like a fitness center and serene courtyard. Ready to elevate your lifestyle? Find your new home and lease online today!",
  "property_contactus_blurb": "At Pearl Point in scenic Rockport, TX, we offer thoughtfully designed one, two, and three-bedroom apartments tailored to your lifestyle. With a variety of floor plans, you’re sure to find the perfect home. Have questions? Contact our leasing team today and let us help you make Pearl Point your new sanctuary!",
  "property_faqs_blurb": "At Pearl Point in Rockport, TX, we cater to your lifestyle with thoughtfully designed one, two, and three-bedroom floor plans. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community. Dive in and find the answers that make your living experience even more enjoyable!",
  "property_floorplans_blurb": "<p>Experience the elegance, quality, and style found only at Pearl Point apartments. Each of our one, two, or three bedroom open-concept floor plans features a full-size washer and dryer and a host of <a href=\"/amenities/\">premium amenities</a>. Choose a home with a spa-inspired tub for a relaxing soak every day!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a <a href=\"/floor-plans/\">new apartment home</a> quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our community and apartments.</p>",
  "property_interactivemap_blurb": "At Pearl Point in Rockport, TX, our diverse floor plans—ranging from spacious one bedrooms to inviting three bedrooms—cater to every lifestyle. Experience modern amenities like a resort-style pool, pet-friendly spaces, and a business center, all enhanced by our interactive community map for easy apartment selection and pricing!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Pearl Point in Rockport, TX, we believe great friends make for great neighbors! With inviting one, two, and three-bedroom floor plans, you and your friends can thrive together in a vibrant community. Share the love—refer a friend today and enjoy the perks of living near those you cherish!",
  "property_residentaccess_blurb": "At Pearl Point in picturesque Rockport, TX, our diverse floor plans—one, two, and three bedrooms—offer the perfect blend of comfort and style. Access your resident portal to effortlessly manage rent payments, schedule maintenance, and stay connected with your community today! ",
  "property_reviews_blurb": "At Pearl Point in Rockport, TX, residents rave about their experience, calling it \"a special gem in a coastal city.\" With exceptional amenities, a welcoming staff, and serene surroundings, you'll feel like you're living in a resort. Join a community where kindness and tranquility reign—your perfect home awaits!",
  "property_created_at": "1752257092027",
  "property_scheduletour_blurb": "At Pearl Point in Rockport, TX, our thoughtfully designed one, two, and three-bedroom floor plans elevate your living experience. With stunning amenities and a vibrant community, there’s no place like home. Ready to see for yourself? Schedule a tour today and hear what our residents love about life at Pearl Point!",
  "property_thankyou_blurb": "Thank you for reaching out! At Pearl Point in Rockport, TX, we offer stylish one, two, and three-bedroom apartment floor plans designed for modern living. Our team will be in touch shortly to help you find your perfect home where comfort meets coastal charm. Stay tuned!",
  "property_virtualtours_blurb": "<p>At Pearl Point, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2026 All Rights Reserved. Pearl Point",
  "property_seo_title_home": "Pearl Point |  Apartments in Rockport, TX",
  "property_seo_description_home": "Discover modern living at Pearl Point in Rockport, TX. Choose from stylish one, two, or three-bedroom apartments with excellent amenities!",
  "property_seo_title_floorplans": "Floor Plans | Rockport, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Pearl Point in Rockport, TX! Choose from one, two, or three-bedroom floor plans tailored for comfort. Browse now!",
  "property_seo_title_amenities": "Amenities | Rockport, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover Pearl Point in Rockport, TX—where luxury meets comfort! Enjoy modern amenities like a fitness center, pool, and pet-friendly spaces.",
  "property_seo_title_gallery": "Gallery | Apartments in Rockport, TX",
  "property_seo_description_gallery": "Experience the charm of Pearl Point in Rockport, TX. Envision your new life in stylish apartments with top-notch amenities. Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Pearl Point Apartments",
  "property_seo_description_virtualtours": "Step inside Pearl Point in Rockport, TX! Experience spacious one to three-bedroom layouts with a virtual tour. Your coastal haven awaits—take a peek!",
  "property_seo_title_interactivemap": "Interactive Map | Pearl Point Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Pearl Point in Rockport, TX! Use our interactive map to explore one, two, and three-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Rockport, TX",
  "property_seo_description_neighborhood": "Uncover Rockport’s hidden gems near Pearl Point. From cozy cafes to scenic parks, see what’s around our vibrant community and find your next favorite spot!",
  "property_seo_title_contact": "Contact Us | Pearl Point",
  "property_seo_description_contact": "Connect with Pearl Point in Rockport, TX! Our leasing team is ready to answer your inquiries about our one-to-three bedroom floor plans. Let's chat!",
  "property_seo_title_faqs": "FAQs | Apartments in Rockport, TX",
  "property_seo_description_faqs": "Find answers to your questions about Pearl Point in Rockport, TX. From amenities to floor plans, our FAQ page has everything you need for comfortable living.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rockport, TX",
  "property_seo_description_reviews": "Join our Pearl Point community in Rockport, TX! Read resident reviews and see why our one, two, and three-bedroom apartments offer unparalleled living.",
  "property_seo_title_applynow": "Apply Now | Apartments in Rockport, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Pearl Point in Rockport, TX! Enjoy spacious layouts, premium amenities, and a pet-friendly vibe. Lease your dream home!",
  "property_seo_title_residentaccess": "Resident Access | Pearl Point",
  "property_seo_description_residentaccess": "Access the Pearl Point resident portal for easy rent payments, maintenance requests, and community updates—all in Rockport, TX!",
  "property_seo_title_referafriend": "Refer A Friend | Pearl Point",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Pearl Point in Rockport, TX, and enjoy a vibrant community filled with fun and friendship.",
  "property_seo_title_scheduletour": "Schedule a Tour | Pearl Point",
  "property_seo_description_scheduletour": "Experience coastal living at Pearl Point in Rockport, TX. Schedule a tour today and uncover your new home overlooking serene waters and vibrant landscapes!",
  "property_seo_title_privacy": "Privacy Policy | Pearl Point",
  "property_seo_description_privacy": "At Pearl Point in Rockport, TX, your privacy is our priority. Learn how we safeguard your information. View our privacy policy for peace of mind today!",
  "property_seo_title_accessibility": "Website Accessibility | Pearl Point",
  "property_seo_description_accessibility": "At Pearl Point, we champion accessibility for all. Discover our commitment to digital inclusion in Rockport, TX, and experience a vibrant community!",
  "property_seo_title_sitemap": "Sitemap | Pearl Point",
  "property_seo_description_sitemap": "Navigate through Pearl Point's site to uncover our vibrant Rockport community, featuring stunning apartments and amenities designed just for you!",
  "property_seo_title_thankyou": "Thank You | Pearl Point",
  "property_seo_description_thankyou": "Thank you for reaching out to Pearl Point in Rockport, TX! We’ll be in touch soon to help you find your perfect new home. Stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Rockport, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293557623",
  "amenities": [
    {
      "id": "custom_74b57b4d-c583-423c-8f57-61656139bc2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Fitness and Conditioning Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0914e466-e8dc-46a1-ba17-1742709c2257",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Boat Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99d8adcd-5db1-4fe2-a7ed-a3280293fea6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ebdc715f-e50e-41ef-ac57-3b7ade312668",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee Cafe",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa931126-e1ac-43e8-abe5-4803bd599bab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_871b7607-9580-4d77-ab10-b20cb89061e3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c27b2928-da67-4eed-8dc5-d8c3cec8affb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Wash Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_769157a3-8bcb-45ac-b99b-90b04c82a892",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Door‑to‑door Valet Trash",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c268ca9-9bc1-4bb2-a27b-61b1da83ef87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Resident Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8cea95ff-dba2-4605-8f3b-12e6bbf4c795",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available*",
      "amount": "false",
      "description": "In Select Apartment Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d14749e-767e-43bc-bb49-07c0b3af744d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Greenspace and Pedestrian Walkway",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0839ca10-6626-45f8-b4b7-e53bf9c72c15",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Large Covered Outdoor Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ac4878d-cd81-401c-ade8-a494a7200283",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_365ae36b-0720-4508-993f-ca4c0edc0c83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Rentable Event Space",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_681d10e5-3fb6-4960-b27c-d39da4f6fb1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Rentable Guest Suite",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c7409ee-2bc5-4205-9339-b643ab83136a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Rentable Storage Units",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2750bc0-53bc-45e8-9286-b9210ceaeeb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be18f748-37bc-43c4-b6ab-f99fc3c7f4bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑style Pools with Aqua Loungers and Social Seating",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b227681-7b64-42d6-b894-7aa8ceb69854",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Scheduled Social Activities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6af0e389-5a3c-4fd0-ba75-cc14c8c435fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "All Appliances LG and the dishwasher, washer and dryers have Bluetooth capabilities",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dd2b11a8-d64c-4ea8-9886-281f819596d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Built‑in Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f4b592c-d24d-44d2-8c1f-59cc1b2db4a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Double Sink Vanity",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_837d2c22-d971-4133-8b00-a293fff7d3ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Eat‑in Kitchen with Peninsula Seating Area*",
      "amount": "false",
      "description": "In Select Apartment Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d408e2b2-0f2a-47e9-98ec-7d068502e0cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Star Stainless Steel Appliances in Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6bb873bc-bd14-49a0-875f-1636d6b1ffa5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑size Washer and Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_85e043e7-2d3c-443f-bc19-213221c22fc5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Gourmet Kitchen with Granite Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_653c253a-2815-4b64-9ef8-6f1866604dbb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Gorgeous Cabinetry with Sleek, Brushed Nickel Hardware",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61cc28c1-3d99-4063-aca8-80c7a95f0cb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Undermount Sinks with Gooseneck Faucet in Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_430c3381-2879-400e-b904-458dd0fc13f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Open‑concept 1, 2, and 3 Bedroom Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_777e6890-c3ab-4f89-8c15-cd52c7d41986",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Outside Storage*",
      "amount": "false",
      "description": "In Select Apartment Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_292c8bfa-d0e2-4260-b74a-34c34da456d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Personal Balcony or Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86403e3d-ed26-40bf-809e-cedb7ec1182b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Recessed and Pendant Lighting*",
      "amount": "false",
      "description": "In Select Apartment Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97980fcd-1e7a-4c04-8d83-17fed0529532",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Resilient Wood‑style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8dec694-a66a-421d-94c6-7d708c3cfd63",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Soft‑close Cabinets in Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_833b6f2c-3ac9-48e0-b3ca-481ea5b870f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Walk‑in Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e3b1142-c21b-4a48-b40e-40c6a2811754",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "external_id": "false",
      "title": "Spa‑inspired Soaking Tubs*",
      "amount": "false",
      "description": "In Select Apartment Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_7773251f-6b1c-4eb7-a496-b5ec5d61e253",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-9be3-72de-b85b-beb62dfb5214.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex outdoor swimming pool with built-in sun loungers and palm trees.",
        "public_id": "019d076e-9be3-72de-b85b-beb62dfb5214",
        "storage_key": "property/6737460151191761/019d076e-9be3-72de-b85b-beb62dfb5214.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our resort-style swimming pool, complete with built-in sun loungers and surrounded by tropical palm trees. Perfect for soaking up the sun and enjoying the beautiful weather.",
      "link": "",
      "alt_text": "Luxury apartment complex outdoor swimming pool with built-in sun loungers and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8790a444-65ea-49c4-b64b-850e1a188117",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-e8a8-76c8-8d5a-f05bac8a4f31.webp",
      "image_media": {
        "alt_text": "Colorful Adirondack chairs arranged in a grassy courtyard with apartment buildings in the background.",
        "public_id": "019d076d-e8a8-76c8-8d5a-f05bac8a4f31",
        "storage_key": "property/6737460151191761/019d076d-e8a8-76c8-8d5a-f05bac8a4f31.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our vibrant outdoor seating area, perfect for enjoying the coastal breeze and community atmosphere.",
      "link": "",
      "alt_text": "Colorful Adirondack chairs arranged in a grassy courtyard with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be1e78d8-108b-4df8-80bb-fcc2742ccdb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-6af3-749a-a86c-1e57b9303b32.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with sofa, coffee table, island with bar stools, and stainless steel appliances.",
        "public_id": "019e6485-6af3-749a-a86c-1e57b9303b32",
        "storage_key": "property/6737460151191761/019e6485-6af3-749a-a86c-1e57b9303b32.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Apartment",
      "description": "Enjoy this bright and airy living room and kitchen space, perfect for relaxing or entertaining. Features modern finishes and ample counter space.",
      "link": "",
      "alt_text": "Modern living room and kitchen with sofa, coffee table, island with bar stools, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ee7821f-291a-4b7c-b576-7e69dba688c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-5ca6-7769-b805-d0fb99410dcb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
        "public_id": "019e6485-5ca6-7769-b805-d0fb99410dcb",
        "storage_key": "property/6737460151191761/019e6485-5ca6-7769-b805-d0fb99410dcb.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring ample cabinet space, sleek granite countertops, and modern stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d701c59-d0a8-4ade-ae57-c238d9273246",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-27dd-779c-af9f-b602f78d4269.webp",
      "image_media": {
        "alt_text": "Modern community kitchen with stainless steel appliances and island seating.",
        "public_id": "019e6485-27dd-779c-af9f-b602f78d4269",
        "storage_key": "property/6737460151191761/019e6485-27dd-779c-af9f-b602f78d4269.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Enjoy our stylish community kitchen, perfect for gatherings or a quick bite.",
      "link": "",
      "alt_text": "Modern community kitchen with stainless steel appliances and island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ffb52c7d-9656-4fe8-ae6e-dfe930d1f821",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-6687-738b-b7d8-a469cd356526.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a granite island with bar stools.",
        "public_id": "019e6485-6687-738b-b7d8-a469cd356526",
        "storage_key": "property/6737460151191761/019e6485-6687-738b-b7d8-a469cd356526.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this beautifully appointed kitchen, featuring sleek white cabinetry, high-end stainless steel appliances, and a chic granite island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a granite island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2b9b4c1-8634-4a55-b087-6335b9ba7404",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-6aba-742d-8d2b-d701bed38e58.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and a glimpse of the bedroom.",
        "public_id": "019e6485-6aba-742d-8d2b-d701bed38e58",
        "storage_key": "property/6737460151191761/019e6485-6aba-742d-8d2b-d701bed38e58.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Apartment",
      "description": "Spacious double vanity bathroom featuring granite countertops, modern fixtures, and a view into the bedroom.",
      "link": "",
      "alt_text": "Double vanity bathroom with granite countertops and a glimpse of the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6ea7a86-7c6a-45b6-9b42-9c27653deafc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-66d7-7414-a72b-b00a640802e4.webp",
      "image_media": {
        "alt_text": "Bathroom with dual vanity, large mirror, bathtub, and toilet.",
        "public_id": "019e6485-66d7-7414-a72b-b00a640802e4",
        "storage_key": "property/6737460151191761/019e6485-66d7-7414-a72b-b00a640802e4.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a dual vanity with granite countertops, a large mirror, a bathtub, and a toilet, offering a clean and modern aesthetic.",
      "link": "",
      "alt_text": "Bathroom with dual vanity, large mirror, bathtub, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02b5663f-7b2e-430c-aea2-aa251b564ac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-4525-706a-a672-35b7fe060468.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
        "public_id": "019e6485-4525-706a-a672-35b7fe060468",
        "storage_key": "property/6737460151191761/019e6485-4525-706a-a672-35b7fe060468.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and pristine white cabinetry. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae296a3b-5fff-464e-9a8f-635ac1c7492f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-4135-76d7-bdcd-006d602360c8.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a ceiling fan and modern appliances.",
        "public_id": "019e6485-4135-76d7-bdcd-006d602360c8",
        "storage_key": "property/6737460151191761/019e6485-4135-76d7-bdcd-006d602360c8.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living area and modern kitchen featuring a ceiling fan, stainless steel appliances, and ample counter space.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with a ceiling fan and modern appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_722c38eb-49eb-4b76-908f-fafe852bd6b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-42b1-7752-9d56-4eb6277f0ae4.webp",
      "image_media": {
        "alt_text": "Spacious living area with a ceiling fan, three windows with blinds, and a glass door.",
        "public_id": "019e6485-42b1-7752-9d56-4eb6277f0ae4",
        "storage_key": "property/6737460151191761/019e6485-42b1-7752-9d56-4eb6277f0ae4.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring a modern ceiling fan, large windows for natural light, and wood-look flooring.",
      "link": "",
      "alt_text": "Spacious living area with a ceiling fan, three windows with blinds, and a glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6c32b7c2-f0d9-468c-99b5-9813eec14bf0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-4b5b-70ff-b0c2-d65adf57700b.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and TV.",
        "public_id": "019e6485-4b5b-70ff-b0c2-d65adf57700b",
        "storage_key": "property/6737460151191761/019e6485-4b5b-70ff-b0c2-d65adf57700b.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Apartment",
      "description": "Spacious and modern living room featuring a comfortable sofa, a stylish armchair, a coffee table, and a large flat-screen TV.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3bb21b7e-379e-401f-b6e4-b8d201afd5b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-398c-7202-a0af-3ca4d71b79b4.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and walk-in closet",
        "public_id": "019e6485-398c-7202-a0af-3ca4d71b79b4",
        "storage_key": "property/6737460151191761/019e6485-398c-7202-a0af-3ca4d71b79b4.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and a convenient walk-in closet, perfect for comfortable living.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and walk-in closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_644a420d-8d56-4690-96d6-6cea456bacb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-4183-71b7-8943-bb420a0c4c02.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and view into kitchen.",
        "public_id": "019e6485-4183-71b7-8943-bb420a0c4c02",
        "storage_key": "property/6737460151191761/019e6485-4183-71b7-8943-bb420a0c4c02.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet and a doorway leading to the kitchen area. This room offers a comfortable and functional living space.",
      "link": "",
      "alt_text": "Bedroom with closet and view into kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3c1a7df-e39e-4053-8c49-2313a2bb4b7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-2bd7-742d-9aaa-415231bcabf5.webp",
      "image_media": {
        "alt_text": "Interior view of a well-equipped fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019e6485-2bd7-742d-9aaa-415231bcabf5",
        "storage_key": "property/6737460151191761/019e6485-2bd7-742d-9aaa-415231bcabf5.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio equipment, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Interior view of a well-equipped fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8dcd9888-c71e-4215-bbe5-3c495469f374",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-250b-7033-9e65-eb31fe2f8053.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a modern kitchen and seating area.",
        "public_id": "019e6485-250b-7033-9e65-eb31fe2f8053",
        "storage_key": "property/6737460151191761/019e6485-250b-7033-9e65-eb31fe2f8053.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a gourmet kitchen and comfortable seating areas perfect for socializing.",
      "link": "",
      "alt_text": "Spacious community lounge with a modern kitchen and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0e5cd46-e062-4937-b4df-0363848f5f1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-2719-735c-bab6-5b446a829c6d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e6485-2719-735c-bab6-5b446a829c6d",
        "storage_key": "property/6737460151191761/019e6485-2719-735c-bab6-5b446a829c6d.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d39e6d1a-368a-49fc-a3eb-95b36d371d9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-096f-7721-bfdd-69a34f3fd1e1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar.",
        "public_id": "019e6485-096f-7721-bfdd-69a34f3fd1e1",
        "storage_key": "property/6737460151191761/019e6485-096f-7721-bfdd-69a34f3fd1e1.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring ample cabinet space, stainless steel appliances, and a stylish breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9af33be2-6e96-489f-a358-65280e3477cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-133e-70d0-b11b-0e2b32a74a59.webp",
      "image_media": {
        "alt_text": "Aerial view of a seaside apartment complex with light blue buildings, a swimming pool, and surrounding landscaping.",
        "public_id": "019e6485-133e-70d0-b11b-0e2b32a74a59",
        "storage_key": "property/6737460151191761/019e6485-133e-70d0-b11b-0e2b32a74a59.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover coastal living at our beautiful apartment community, featuring stunning architecture, a refreshing swimming pool, and lush green spaces.",
      "link": "",
      "alt_text": "Aerial view of a seaside apartment complex with light blue buildings, a swimming pool, and surrounding landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de1e5a7e-ff8b-4f98-8ed6-7651364a4460",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-d603-710a-80c5-43000f4c7429.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with colorful seating, tables, and a giant connect four game.",
        "public_id": "019d076d-d603-710a-80c5-43000f4c7429",
        "storage_key": "property/6737460151191761/019d076d-d603-710a-80c5-43000f4c7429.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and socialize in our vibrant outdoor lounge, complete with comfortable seating, tables, and engaging games for all residents.",
      "link": "",
      "alt_text": "Covered outdoor lounge area with colorful seating, tables, and a giant connect four game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_881f5c49-bbcd-4d77-9407-e5626f95b384",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-0d59-7691-bae3-d2b9dc977e01.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and a glimpse of a bedroom.",
        "public_id": "019e6485-0d59-7691-bae3-d2b9dc977e01",
        "storage_key": "property/6737460151191761/019e6485-0d59-7691-bae3-d2b9dc977e01.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Step into this chic apartment bathroom, featuring a spacious double vanity with elegant granite countertops and modern fixtures. A peek into the bedroom offers a view of the comfortable living space.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and a glimpse of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c858950d-baee-44f9-86c2-9ecbe8be7ab7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-0c2f-721c-8449-1f268d885b6a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and a bathtub with shower.",
        "public_id": "019e6485-0c2f-721c-8449-1f268d885b6a",
        "storage_key": "property/6737460151191761/019e6485-0c2f-721c-8449-1f268d885b6a.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, a modern bathtub with shower, and ample storage space. Enjoy a spa-like experience in your new apartment.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and a bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75109dab-d7fb-47e6-b28c-353ca6b81b32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-d248-77de-8eaf-32d78f391667.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and weight machines in a well-lit fitness center.",
        "public_id": "019d076d-d248-77de-8eaf-32d78f391667",
        "storage_key": "property/6737460151191761/019d076d-d248-77de-8eaf-32d78f391667.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Treadmills, ellipticals, and weight machines in a well-lit fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e1bf2549-02c6-4da7-a890-76f390bf3b57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-d87b-75c6-aa27-beb672495433.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabana at an apartment complex.",
        "public_id": "019d076d-d87b-75c6-aa27-beb672495433",
        "storage_key": "property/6737460151191761/019d076d-d87b-75c6-aa27-beb672495433.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy our sparkling resort-style swimming pool, complete with comfortable lounge seating and a shaded cabana, perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabana at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eaa6bed0-08f2-4b3c-a84e-f4978fb23659",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-d086-765f-8591-488c1777c46e.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019d076d-d086-765f-8591-488c1777c46e",
        "storage_key": "property/6737460151191761/019d076d-d086-765f-8591-488c1777c46e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our expansive outdoor swimming pool, surrounded by comfortable lounge chairs and lush palm trees. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and a resort-style building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4276e1a2-42b7-44aa-8234-26c9371715d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-0bcc-7358-80fe-d860d28873fe.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019e6485-0bcc-7358-80fe-d860d28873fe",
        "storage_key": "property/6737460151191761/019e6485-0bcc-7358-80fe-d860d28873fe.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample cabinet space, sleek granite countertops, and stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b47462e-df50-4bb5-bcb6-9ecec4b200aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6485-0aaa-76da-9933-89091c39aa07.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, armchair, and TV.",
        "public_id": "019e6485-0aaa-76da-9933-89091c39aa07",
        "storage_key": "property/6737460151191761/019e6485-0aaa-76da-9933-89091c39aa07.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, modern coffee table, accent armchair, and a wall-mounted television.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, armchair, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ee8bdb2-084f-4adb-bda5-d872f714e838",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-edb5-737b-916b-76767ab66211.webp",
      "image_media": {
        "alt_text": "Empty living room with wood-look flooring, blinds on windows, and a ceiling fan.",
        "public_id": "019e6484-edb5-737b-916b-76767ab66211",
        "storage_key": "property/6737460151191761/019e6484-edb5-737b-916b-76767ab66211.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious living area with abundant natural light, ceiling fan, and access to a balcony or patio. Modern finishes and neutral tones create a welcoming atmosphere.",
      "link": "",
      "alt_text": "Empty living room with wood-look flooring, blinds on windows, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_026cf014-f605-46f1-a9a1-df176b634a6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-ed09-745c-8404-5d40a3fdebd2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
        "public_id": "019e6484-ed09-745c-8404-5d40a3fdebd2",
        "storage_key": "property/6737460151191761/019e6484-ed09-745c-8404-5d40a3fdebd2.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this beautifully designed kitchen, featuring ample cabinet space, a full suite of stainless steel appliances, and a spacious island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0dda5ada-e766-4eca-bb62-6f5502cb05f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-f059-744b-8f06-f4d6519a5d45.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and exercise balls.",
        "public_id": "019e6484-f059-744b-8f06-f4d6519a5d45",
        "storage_key": "property/6737460151191761/019e6484-f059-744b-8f06-f4d6519a5d45.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio and strength training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, weight machines, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc863e15-ce2f-423b-ab12-59c1ce2a5b14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-ec47-776e-be9c-12007b26d63a.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and view into kitchen",
        "public_id": "019e6484-ec47-776e-be9c-12007b26d63a",
        "storage_key": "property/6737460151191761/019e6484-ec47-776e-be9c-12007b26d63a.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large walk-in closet and a view into the adjacent kitchen area. Ample space for furniture and personalization.",
      "link": "",
      "alt_text": "Bedroom with closet and view into kitchen",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27f66cf9-85ef-4783-8b3e-8987b3ebc22b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-ef7d-733a-ac83-d04661059f79.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
        "public_id": "019e6484-ef7d-733a-ac83-d04661059f79",
        "storage_key": "property/6737460151191761/019e6484-ef7d-733a-ac83-d04661059f79.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8deef6a-c551-4079-8f4c-8c2be5e2cffe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-ebf7-77b6-a95a-f95219228a99.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets.",
        "public_id": "019e6484-ebf7-77b6-a95a-f95219228a99",
        "storage_key": "property/6737460151191761/019e6484-ebf7-77b6-a95a-f95219228a99.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample white cabinetry for all your storage needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f2f18aa-7d7e-4976-aa9c-9ef763d514f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-ee16-7708-92d2-ba2f108e5444.webp",
      "image_media": {
        "alt_text": "Modern lounge area with kitchen and seating in a multifamily property.",
        "public_id": "019e6484-ee16-7708-92d2-ba2f108e5444",
        "storage_key": "property/6737460151191761/019e6484-ee16-7708-92d2-ba2f108e5444.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Relax and socialize in the stylish lounge area, featuring a gourmet kitchen and comfortable seating, perfect for residents.",
      "link": "",
      "alt_text": "Modern lounge area with kitchen and seating in a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d2f5c4a0-f70d-4f8b-bb65-47bed99c33dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-efd2-74d1-947a-261f0523573d.webp",
      "image_media": {
        "alt_text": "Open concept living area with modern kitchen and dining bar.",
        "public_id": "019e6484-efd2-74d1-947a-261f0523573d",
        "storage_key": "property/6737460151191761/019e6484-efd2-74d1-947a-261f0523573d.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a comfortable sofa, coffee table, and a sleek kitchen with stainless steel appliances and a breakfast bar.",
      "link": "",
      "alt_text": "Open concept living area with modern kitchen and dining bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_400dbf57-9e4b-41a7-a511-4af2902f3c55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-ec17-71ca-9931-9c3fa97af880.webp",
      "image_media": {
        "alt_text": "Interior view of a bedroom with a ceiling fan and a closet.",
        "public_id": "019e6484-ec17-71ca-9931-9c3fa97af880",
        "storage_key": "property/6737460151191761/019e6484-ec17-71ca-9931-9c3fa97af880.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and ample closet space, ready for your personal touch.",
      "link": "",
      "alt_text": "Interior view of a bedroom with a ceiling fan and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1250279e-32db-4933-8c89-8a3fc886b7e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019e6484-edef-7216-ba38-33397f5b006e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with modern finishes and a ceiling fan.",
        "public_id": "019e6484-edef-7216-ba38-33397f5b006e",
        "storage_key": "property/6737460151191761/019e6484-edef-7216-ba38-33397f5b006e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living area flows into a modern kitchen, perfect for entertaining. Features include a ceiling fan and stylish pendant lighting.",
      "link": "",
      "alt_text": "Living room and kitchen area with modern finishes and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a74b5d89-25a3-459a-b8b6-cad0d86804a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-9be3-72de-b85b-c40c0b01aea9.webp",
      "image_media": {
        "alt_text": "Exterior of light blue apartment buildings with balconies and palm trees in a grassy courtyard.",
        "public_id": "019d076e-9be3-72de-b85b-c40c0b01aea9",
        "storage_key": "property/6737460151191761/019d076e-9be3-72de-b85b-c40c0b01aea9.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Beautiful exterior view of the apartment buildings, featuring light blue siding, white balconies, and lush green landscaping with palm trees.",
      "link": "",
      "alt_text": "Exterior of light blue apartment buildings with balconies and palm trees in a grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fda0d2a1-3748-46a6-ba1c-e278a25d20ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-23a6-7289-8ad7-99cd02036be8.webp",
      "image_media": {
        "alt_text": "Balcony with a small table and chairs, overlooking the community pool and buildings.",
        "public_id": "019d076e-23a6-7289-8ad7-99cd02036be8",
        "storage_key": "property/6737460151191761/019d076e-23a6-7289-8ad7-99cd02036be8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, with a view of the sparkling community pool and lush green spaces.",
      "link": "",
      "alt_text": "Balcony with a small table and chairs, overlooking the community pool and buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e32b3c80-1592-4791-b625-5d3dfc1f8b33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-f560-7423-a07d-ff58d46fb253.webp",
      "image_media": {
        "alt_text": "Mailroom with rows of mailboxes",
        "public_id": "019d076d-f560-7423-a07d-ff58d46fb253",
        "storage_key": "property/6737460151191761/019d076d-f560-7423-a07d-ff58d46fb253.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Secure and organized mailroom featuring numerous mailboxes for resident convenience.",
      "link": "",
      "alt_text": "Mailroom with rows of mailboxes",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4016b477-3737-467e-a689-be2be9f98910",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-f561-73ae-a665-225a0f14092d.webp",
      "image_media": {
        "alt_text": "Exterior view of a row of garages at a multifamily property.",
        "public_id": "019d076d-f561-73ae-a665-225a0f14092d",
        "storage_key": "property/6737460151191761/019d076d-f561-73ae-a665-225a0f14092d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Secure your vehicle in one of our convenient garages, available for rent.",
      "link": "",
      "alt_text": "Exterior view of a row of garages at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_952402f9-5d06-4320-b0a1-597caa092bff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076d-dc5b-7047-b015-0c52b4d62df1.webp",
      "image_media": {
        "alt_text": "Lounge chairs in front of apartment buildings and pool area.",
        "public_id": "019d076d-dc5b-7047-b015-0c52b4d62df1",
        "storage_key": "property/6737460151191761/019d076d-dc5b-7047-b015-0c52b4d62df1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling pool, surrounded by comfortable lounge chairs and lush palm trees. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Lounge chairs in front of apartment buildings and pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d230b867-6eca-4b47-9f33-e3d958c97f9b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Charlotte Plummers",
      "poi_type": "Restaurants",
      "poi_address": "202 N Fulton Beach Rd, Rockport, TX 78382, USA",
      "poi_short_description": "Longtime waterfront pick for seafood platters, shrimp gumbo & more with indoor & outdoor dining.",
      "poi_long_description": "Longtime waterfront pick for seafood platters, shrimp gumbo & more with indoor & outdoor dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-88f1-748b-b096-6196750a2848.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor dining area with tables and chairs overlooking the water.",
        "public_id": "019d595d-88f1-748b-b096-6196750a2848",
        "storage_key": "property/6737460151191761/019d595d-88f1-748b-b096-6196750a2848.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.charlotteplummers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5111372611437940099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-plummers",
      "poi_latitude": "28.0630757",
      "poi_longitude": "-97.0342805",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-1185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76i6L0-0aYYRg01rE08-70Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_bab5b371-5c11-42a9-a8c3-0028b2de3e09",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Pier 77 of Fulton",
      "poi_type": "Restaurants",
      "poi_address": "3307 TX-35, Rockport, TX 78382, USA",
      "poi_short_description": "Casual restaurant offering a BYOB policy, large portions, and a menu featuring Cajun-style seafood, and steaks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595b-d9c9-73cf-9b2b-2fa07f98fe1d.webp",
      "poi_featured_image_media": {
        "alt_text": "Pier 77 restaurant counter with employee serving drinks and food to-go bags on shelf.",
        "public_id": "019d595b-d9c9-73cf-9b2b-2fa07f98fe1d",
        "storage_key": "property/6737460151191761/019d595b-d9c9-73cf-9b2b-2fa07f98fe1d.webp",
        "width": 3072,
        "height": 1435
      },
      "poi_business_url": "https://www.facebook.com/Pier77ofFulton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4740051531065821126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pier-77-of-fulton",
      "poi_latitude": "28.0633018",
      "poi_longitude": "-97.0417393",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-450-0132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU4DX_iS1aYYRxoc57sALyEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_725d2af9-a7df-418b-9d47-a6b211db3406",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Paradise Key Dockside Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "165 Cove Harbor N, Rockport, TX 78382, USA",
      "poi_short_description": "Scenic American bar & grill serving burgers, seafood & tropical drinks in a waterfront setting.",
      "poi_long_description": "Scenic American bar & grill serving burgers, seafood & tropical drinks in a waterfront setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595b-e517-74cf-959d-26a19312f334.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a restaurant with tables and chairs, large windows, and a blue ceiling.",
        "public_id": "019d595b-e517-74cf-959d-26a19312f334",
        "storage_key": "property/6737460151191761/019d595b-e517-74cf-959d-26a19312f334.webp",
        "width": 3072,
        "height": 1435
      },
      "poi_business_url": "http://www.paradisekeydocksidebarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1130946000869024273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paradise-key-dockside-bar--grill",
      "poi_latitude": "27.9923496",
      "poi_longitude": "-97.0726025",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 361-729-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89ca-711b-8bf5-6075cb99d401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89ca-711b-8bf5-6075cb99d401",
        "storage_key": "property/6737460151191761/019d076e-89ca-711b-8bf5-6075cb99d401.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm7sjWTyzaYYREWLyUWXtsQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_dae1fccb-ca3c-4a9b-bb43-b41667597abe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Gabriela's Seafood + Tapas",
      "poi_type": "Restaurants",
      "poi_address": "1815 Broadway St, Rockport, TX 78382, USA",
      "poi_short_description": "Intimate, homey space in a converted boathouse for inventive seafood dinners, plus Sunday brunch.",
      "poi_long_description": "Intimate, homey space in a converted boathouse for inventive seafood dinners, plus Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-8765-755f-8014-ebd2ea86293f.webp",
      "poi_featured_image_media": {
        "alt_text": "Dining area with tables and chairs overlooking a waterfront view.",
        "public_id": "019d595d-8765-755f-8014-ebd2ea86293f",
        "storage_key": "property/6737460151191761/019d595d-8765-755f-8014-ebd2ea86293f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.gabrielasrockport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=392370593949781595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gabrielas-seafood--tapas",
      "poi_latitude": "28.0462438",
      "poi_longitude": "-97.0351002",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-727-2644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-OVeWm0aYYRW46v8Pn6cQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tapas_restaurant"
    },
    {
      "id": "custom_b71830e7-2764-4a68-ba48-ce70b9c74183",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "The Groove Steak & Lobster House",
      "poi_type": "Restaurants",
      "poi_address": "2001 Business, Hwy 35 N Bypass, Rockport, TX 78382, USA",
      "poi_short_description": "Steaks, seafood, wood-fired pizzas & wine in a warm, intimate dining room with a patio.",
      "poi_long_description": "Steaks, seafood, wood-fired pizzas & wine in a warm, intimate dining room with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-8656-7558-a710-55a2e4312acd.webp",
      "poi_featured_image_media": {
        "alt_text": "Pizza oven with \"The Groove\" logo",
        "public_id": "019d595d-8656-7558-a710-55a2e4312acd",
        "storage_key": "property/6737460151191761/019d595d-8656-7558-a710-55a2e4312acd.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.thegrooverockport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1989905855094061335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-groove-steak--lobster-house",
      "poi_latitude": "28.0442131",
      "poi_longitude": "-97.0429063",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_5tlGa0aYYRF_lZDdWQnRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4acb5c29-42f8-4a1b-8a3e-0af2bc532445",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "LA ARANDINA COCINA & CANTINA",
      "poi_type": "Restaurants",
      "poi_address": "609 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "Simple Mexican eatery serving tacos, fajitas & other classics along with beer & tequila drinks.",
      "poi_long_description": "Simple Mexican eatery serving tacos, fajitas & other classics along with beer & tequila drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-8699-74cb-aeb8-a4849ad12067.webp",
      "poi_featured_image_media": {
        "alt_text": "Two women toasting cocktails at a bar during happy hour.",
        "public_id": "019d595d-8699-74cb-aeb8-a4849ad12067",
        "storage_key": "property/6737460151191761/019d595d-8699-74cb-aeb8-a4849ad12067.webp",
        "width": 1320,
        "height": 743
      },
      "poi_business_url": "http://www.facebook.com/LaArandinaRockport",
      "poi_directions_map_url": "https://maps.google.com/?cid=8477002799725328210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-arandina-cocina--cantina",
      "poi_latitude": "28.0287031",
      "poi_longitude": "-97.0486871",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-727-9151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6NaoFu0aYYRUreeHSJdpHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9e6ba2b6-5f95-40b1-b33d-8cdb90be4ea4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Bellino's Italian Restaurant Rockport",
      "poi_type": "Restaurants",
      "poi_address": "523 Fulton Beach Rd, Rockport, TX 78382, USA",
      "poi_short_description": "Classic Italian pastas, seafood & veal dishes are served in a cozy setting hung with homey curios.",
      "poi_long_description": "Classic Italian pastas, seafood & veal dishes are served in a cozy setting hung with homey curios.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-8e78-770d-80f1-cd78f3858165.webp",
      "poi_featured_image_media": {
        "alt_text": "A plate of chicken parmesan with a side of spaghetti and green beans.",
        "public_id": "019d595d-8e78-770d-80f1-cd78f3858165",
        "storage_key": "property/6737460151191761/019d595d-8e78-770d-80f1-cd78f3858165.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://m.facebook.com/bellinorockport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1702629216603401013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellinos-italian-restaurant-rockport",
      "poi_latitude": "28.0529181",
      "poi_longitude": "-97.0341494",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-729-9003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-ueVUG0aYYRNevYZ0D0oBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c99a8b3e-fd08-46f5-ae3e-9f387883ccf1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Panjo's Pizza & Pasta",
      "poi_type": "Restaurants",
      "poi_address": "2744 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "Homey pizza place with a menu spanning burgers, pasta, spaghetti and other dishes, plus wine and beer, also featuring a kids' menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-8765-755f-8014-ef3e55c2a152.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a strip mall with multiple businesses, including a pizza place and law offices.",
        "public_id": "019d595d-8765-755f-8014-ef3e55c2a152",
        "storage_key": "property/6737460151191761/019d595d-8765-755f-8014-ef3e55c2a152.webp",
        "width": 3072,
        "height": 1435
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6852233525423300269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panjos-pizza--pasta",
      "poi_latitude": "28.055468",
      "poi_longitude": "-97.04051",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-1411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9So9gly0aYYRrd7gMBYGGF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_57c65595-bd96-40c8-b2c6-d4d4f91c5052",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Yarbaritas Sip & Swing",
      "poi_type": "Restaurants",
      "poi_address": "1329 Broadway St, Rockport, TX 78382, USA",
      "poi_short_description": "Casual eatery featuring a 2-story deck with hammock swings and Gulf views, serving seafood and other American eats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-9507-72d0-85a8-aff1276b30c0.webp",
      "poi_featured_image_media": {
        "alt_text": "Covered outdoor seating area with a view of the water and palm trees.",
        "public_id": "019d595d-9507-72d0-85a8-aff1276b30c0",
        "storage_key": "property/6737460151191761/019d595d-9507-72d0-85a8-aff1276b30c0.webp",
        "width": 3072,
        "height": 1650
      },
      "poi_business_url": "http://yarbaritas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11862547304743627535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yarbaritas-sip--swing",
      "poi_latitude": "28.0376726",
      "poi_longitude": "-97.0411346",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-450-8077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUnW2PG1aYYRD-uCVuw7oKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_8f974ae5-513e-4de5-95a8-5ca275aa8b44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Old Fulton Seafood Cafe & Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "2828 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "A menu specializing in American seafood dishes & comfort food in a relaxed space with patio seating.",
      "poi_long_description": "A menu specializing in American seafood dishes & comfort food in a relaxed space with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-95df-711f-80bd-67d404af14cf.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Old Fulton Seafood Cafe & Steakhouse and Cross Eyed Martini",
        "public_id": "019d595d-95df-711f-80bd-67d404af14cf",
        "storage_key": "property/6737460151191761/019d595d-95df-711f-80bd-67d404af14cf.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.oldfultonseafoodcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8312474411795870834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-fulton-seafood-cafe--steakhouse",
      "poi_latitude": "28.0560464",
      "poi_longitude": "-97.0406448",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-729-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjafqWE-0aYYRcvSdp2_XW3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_102f3db8-8739-4d40-a596-1293aac411db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "The Boiling Pot",
      "poi_type": "Restaurants",
      "poi_address": "201 Fulton Beach Rd, Rockport, TX 78382, USA",
      "poi_short_description": "Lively, long-running joint serving heaps of Cajun-spiced, boiled seafood in down-home, beachy digs.",
      "poi_long_description": "Lively, long-running joint serving heaps of Cajun-spiced, boiled seafood in down-home, beachy digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595b-dbcc-76bd-9f80-421945a0e7c1.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor seating area with picnic tables and lush greenery under a shaded canopy.",
        "public_id": "019d595b-dbcc-76bd-9f80-421945a0e7c1",
        "storage_key": "property/6737460151191761/019d595b-dbcc-76bd-9f80-421945a0e7c1.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.theboilingpotrockport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10197450621166320241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boiling-pot",
      "poi_latitude": "28.0599406",
      "poi_longitude": "-97.0346975",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-6972",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZpR7kW0aYYRcXo0wU-fhI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_a74df8aa-b487-49a8-bb7e-54eaa8750709",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Mac's Pit Barbecue & Catering",
      "poi_type": "Restaurants",
      "poi_address": "815 E Market St, Rockport, TX 78382, USA",
      "poi_short_description": "Simple BBQ joint featuring sandwiches, plates & classic sides, plus a drive-thru.",
      "poi_long_description": "Simple BBQ joint featuring sandwiches, plates & classic sides, plus a drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-b272-7496-9314-3840c25cf1ce.webp",
      "poi_featured_image_media": {
        "alt_text": "Community dining hall with tables set up and taxidermied animal heads on the wall.",
        "public_id": "019d595d-b272-7496-9314-3840c25cf1ce",
        "storage_key": "property/6737460151191761/019d595d-b272-7496-9314-3840c25cf1ce.webp",
        "width": 3072,
        "height": 2307
      },
      "poi_business_url": "http://macspitbarbecue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1410289639274258215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macs-pit-barbecue--catering",
      "poi_latitude": "28.02014",
      "poi_longitude": "-97.0541206",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-729-9388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHYgUuX6zaYYRJx9bc_RakhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_5f9b9378-1155-4acb-83f9-e683e4ead8ec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Donut Palace",
      "poi_type": "Restaurants",
      "poi_address": "301 E Liberty St, Rockport, TX 78382, USA",
      "poi_short_description": "Donut shop with a large variety of flavors including kolaches, pigs in a blanket, and cinnamon rolls.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-b141-70af-b2a5-2684e324f22a.webp",
      "poi_featured_image_media": {
        "alt_text": "A box of assorted donuts.",
        "public_id": "019d595d-b141-70af-b2a5-2684e324f22a",
        "storage_key": "property/6737460151191761/019d595d-b141-70af-b2a5-2684e324f22a.webp",
        "width": 1730,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1940825790960071543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donut-palace",
      "poi_latitude": "28.0268127",
      "poi_longitude": "-97.057676",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-727-9930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbcL0-oK0aYYRd3MXIcYy7xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_34831dc0-c73c-4547-ae8f-82c8e2a1fcb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "The Palm Room Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "200 Fulton Beach Rd, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-ae0b-7118-baf0-c846f610633d.webp",
      "poi_featured_image_media": {
        "alt_text": "Dining area with tables and chairs by the window.",
        "public_id": "019d595d-ae0b-7118-baf0-c846f610633d",
        "storage_key": "property/6737460151191761/019d595d-ae0b-7118-baf0-c846f610633d.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12382919931781640139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-palm-room-bar--grill",
      "poi_latitude": "28.0596607",
      "poi_longitude": "-97.0338041",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-790-8439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89bf-707d-9e95-627a6b345b9b",
        "storage_key": "property/6737460151191761/019d076e-89bf-707d-9e95-627a6b345b9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJcBJJqa1aYYRy-_yBxL42Ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8ea97aed-2cd5-4827-9457-3c57ef878595",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "1409 Hwy 35 N Business, Rockport, TX 78382, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-5382-735a-bef7-dc09bd72bd5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-5382-735a-bef7-dc09bd72bd5b",
        "storage_key": "property/6737460151191761/019d076e-5382-735a-bef7-dc09bd72bd5b.webp",
        "width": 1144,
        "height": 644
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/rockport/rockport-h-e-b-562?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=7633816346584950692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "28.0387772",
      "poi_longitude": "-97.044118",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-8230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89cc-72ba-ac4b-cc55003faae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89cc-72ba-ac4b-cc55003faae6",
        "storage_key": "property/6737460151191761/019d076e-89cc-72ba-ac4b-cc55003faae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2dlGMhMaIYRpCfEgoXD8Gk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_65c6f000-7d3d-4b12-91a2-c77cc3c7c207",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2401 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "Chain department store selling apparel, home furnishings, and groceries, plus sporting goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-b8b0-71ac-aeb3-e3f7c60ce662.webp",
      "poi_featured_image_media": {
        "alt_text": "Walmart logo on the exterior of a store.",
        "public_id": "019d595d-b8b0-71ac-aeb3-e3f7c60ce662",
        "storage_key": "property/6737460151191761/019d595d-b8b0-71ac-aeb3-e3f7c60ce662.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/440-rockport-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7597130376811611004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "28.0481493",
      "poi_longitude": "-97.0449712",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-729-9277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89ff-75fb-b799-efb192f27cb6",
        "storage_key": "property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoSiKMTbnQIYRfIMvjtNtbmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2985d41d-3979-476f-96c7-2816f6ec71b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1309 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-b9cf-742d-ac83-8dad2c40b481.webp",
      "poi_featured_image_media": {
        "alt_text": "A retail shelf stocked with bottles of wine.",
        "public_id": "019d595d-b9cf-742d-ac83-8dad2c40b481",
        "storage_key": "property/6737460151191761/019d595d-b9cf-742d-ac83-8dad2c40b481.webp",
        "width": 1080,
        "height": 1920
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1309+highway+35+n-rockport-tx-78382/id=9205",
      "poi_directions_map_url": "https://maps.google.com/?cid=6304491502741221497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.0372486",
      "poi_longitude": "-97.0431751",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-8706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLwC4IMhMaIYRefBbfp4Nflc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_71856ee8-5b79-4119-8dcb-1b1fda032b62",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 W Market St, Rockport, TX 78382, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-b9e1-7339-8c34-6eb5d739cae2.webp",
      "poi_featured_image_media": {
        "alt_text": "Family Dollar store exterior with signage",
        "public_id": "019d595d-b9e1-7339-8c34-6eb5d739cae2",
        "storage_key": "property/6737460151191761/019d595d-b9e1-7339-8c34-6eb5d739cae2.webp",
        "width": 1353,
        "height": 900
      },
      "poi_business_url": "https://locations.familydollar.com/tx/rockport/1001-w-market-st?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6885729416967101133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "28.0254245",
      "poi_longitude": "-97.0721247",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-556-5084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89ff-75fb-b799-efb192f27cb6",
        "storage_key": "property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPYegIui1aYYRzRrILWwGj18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_4303af27-5d64-4467-a761-5372a86fbc79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "832 TX-35 BUS S, Rockport, TX 78382, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-c25a-75af-aaf8-7d0b13bc8b15.webp",
      "poi_featured_image_media": {
        "alt_text": "Dollar General store exterior with a large yellow sign and shopping carts.",
        "public_id": "019d595d-c25a-75af-aaf8-7d0b13bc8b15",
        "storage_key": "property/6737460151191761/019d595d-c25a-75af-aaf8-7d0b13bc8b15.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tx/rockport/19720",
      "poi_directions_map_url": "https://maps.google.com/?cid=2687640531651766941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "28.0184434",
      "poi_longitude": "-97.0608093",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-247-2710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89ff-75fb-b799-efb192f27cb6",
        "storage_key": "property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN51VynyzaYYRnaoL5dJqTCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_d1a47c53-cf3a-47c5-8986-a1295570caca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1802 W Market St, Rockport, TX 78382, USA",
      "poi_short_description": "Gas station and convenience store offering coffee and other beverages, plus prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-c59b-701f-99f6-be60fdb4591d.webp",
      "poi_featured_image_media": {
        "alt_text": "Gas station with Valero and Circle K brands.",
        "public_id": "019d595d-c59b-701f-99f6-be60fdb4591d",
        "storage_key": "property/6737460151191761/019d595d-c59b-701f-99f6-be60fdb4591d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/rockport/1802-w-market-st/2741499?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2855588808407549241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "28.0299834",
      "poi_longitude": "-97.0832263",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 361-556-5252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e45-73ab-a8a7-630f5cfc23dd.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d595e-9e45-73ab-a8a7-630f5cfc23dd",
        "storage_key": "property/6737460151191761/019d595e-9e45-73ab-a8a7-630f5cfc23dd.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJSV1_i5-0aYYROYW2ReQWoSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_a54422d9-7273-45d2-b60b-bbe3e47b80e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "The Coastal Mercantile",
      "poi_type": "Shopping & Retail",
      "poi_address": "406 S Austin St, Rockport, TX 78382, USA",
      "poi_short_description": "Mercantile shop stocking gifts and decor, plus a wine bar and patio with live tunes and a food truck.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-c5e6-723f-9d92-775de1bc235c.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of The Coastal Mercantile building with brick facade and signage, illuminated at dusk.",
        "public_id": "019d595d-c5e6-723f-9d92-775de1bc235c",
        "storage_key": "property/6737460151191761/019d595d-c5e6-723f-9d92-775de1bc235c.webp",
        "width": 828,
        "height": 552
      },
      "poi_business_url": "https://thecoastalmercantile.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15473759304656318666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-coastal-mercantile",
      "poi_latitude": "28.021043",
      "poi_longitude": "-97.0511828",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-450-1044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89ff-75fb-b799-efb192f27cb6",
        "storage_key": "property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGefgIn-zaYYRynDvpRrWvdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_95b311f3-fe2f-40a1-95dd-cd24826890e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport Tackle Town",
      "poi_type": "Shopping & Retail",
      "poi_address": "3010 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "Store offering an array of clothing, tools, and other gear for fishing and hunting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-c790-768a-a0e6-eaa4e07767af.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of Tackle Town store with a blue roof and brown facade.",
        "public_id": "019d595d-c790-768a-a0e6-eaa4e07767af",
        "storage_key": "property/6737460151191761/019d595d-c790-768a-a0e6-eaa4e07767af.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.rockporttackletown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12842040955479227006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-tackle-town",
      "poi_latitude": "28.059332",
      "poi_longitude": "-97.040768",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-729-1841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89ff-75fb-b799-efb192f27cb6",
        "storage_key": "property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK1ebZVC0aYYRfnpbfjUYOLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_6ecfcc4f-aaac-481a-a948-d882c08c4593",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Treasure Islander Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "301 S Austin St, Rockport, TX 78382, USA",
      "poi_short_description": "Store offering a variety of gifts and souvenirs, including apparel, coffee cups, and wind chimes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-c70e-76af-8713-336f732166ac.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of the Treasure Islander shop.",
        "public_id": "019d595d-c70e-76af-8713-336f732166ac",
        "storage_key": "property/6737460151191761/019d595d-c70e-76af-8713-336f732166ac.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3274273995025298621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "treasure-islander-shop",
      "poi_latitude": "28.0220683",
      "poi_longitude": "-97.0513699",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-3057",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-89ff-75fb-b799-efb192f27cb6",
        "storage_key": "property/6737460151191761/019d076e-89ff-75fb-b799-efb192f27cb6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG_dYCn-zaYYRvTTIwtmOcC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_cca2eb04-de6b-4f7f-9cdb-c64be10c8013",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Little Bay Primary",
      "poi_type": "Education",
      "poi_address": "2000 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://acisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12455143149105708550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-bay-primary",
      "poi_latitude": "28.0444134",
      "poi_longitude": "-97.0421501",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_1oa9Wa0aYYRBv4VNbSO2aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f551c582-27f2-49a0-8a61-5b7f5ef91ca9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Live Oak Learning Center",
      "poi_type": "Education",
      "poi_address": "31 Griffith Dr, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lolc.rfisd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16265319670350123860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "live-oak-learning-center",
      "poi_latitude": "28.0295185",
      "poi_longitude": "-97.088285",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-790-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe1rD-qu0aYYRVJNkFRAGuuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e0134508-30f5-45d2-bb58-ab48fcd9fb8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Fulton Learning Center",
      "poi_type": "Education",
      "poi_address": "314 N 6th St, Fulton, TX 78358, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://flc.rfisd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11569428449618637021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fulton-learning-center",
      "poi_latitude": "28.064517",
      "poi_longitude": "-97.038883",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTXKQZLS1aYYR3TDRoeDdjqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_991379c4-a3e0-45b6-a816-025dcd0902d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport-Fulton Middle School",
      "poi_type": "Education",
      "poi_address": "1701 Colorado St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rfms.rfisd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8075491057524233525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-fulton-middle-school",
      "poi_latitude": "28.0450874",
      "poi_longitude": "-97.0459223",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkR3G4ma0aYYRNVWTvlToEXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d3b02ed4-84a3-4283-bd50-adb8aea1d98d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport - Fulton High School",
      "poi_type": "Education",
      "poi_address": "1801 Omohundro St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-d5eb-7309-99fd-41a45345311f.webp",
      "poi_featured_image_media": {
        "alt_text": "View of a bay with houses and a palm tree.",
        "public_id": "019d595d-d5eb-7309-99fd-41a45345311f",
        "storage_key": "property/6737460151191761/019d595d-d5eb-7309-99fd-41a45345311f.webp",
        "width": 1152,
        "height": 1920
      },
      "poi_business_url": "https://rfhs.rfisd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15743493688427017456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport---fulton-high-school",
      "poi_latitude": "28.0408019",
      "poi_longitude": "-97.0450123",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-790-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUYOB_GO0aYYR8PRL1hggfNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8457b795-91bf-422a-a6fb-f4232a8dfaaa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "CCAC Coastal Bend Child Development Center",
      "poi_type": "Education",
      "poi_address": "922 Hwy 35 S, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595b-e187-76e1-b053-14aea61a7285.webp",
      "poi_featured_image_media": {
        "alt_text": "Toddler boy putting items into a Christmas stocking next to bins of building blocks.",
        "public_id": "019d595b-e187-76e1-b053-14aea61a7285",
        "storage_key": "property/6737460151191761/019d595b-e187-76e1-b053-14aea61a7285.webp",
        "width": 1200,
        "height": 1600
      },
      "poi_business_url": "https://www.childrenscoalitionac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5595770881239979241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ccac-coastal-bend-child-development-center",
      "poi_latitude": "28.0174433",
      "poi_longitude": "-97.0613443",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-900-2151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP1arfAKzaYYR6ZTIBPgrqE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_11b52b29-e221-49b9-af70-a0c2f50fd4c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "First Learning Tree Day Care",
      "poi_type": "Education",
      "poi_address": "503 S Live Oak St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-d899-702f-9dfe-fdc8c2d2c93e.webp",
      "poi_featured_image_media": {
        "alt_text": "First Learning Tree building entrance with a porch, rocking chairs, and landscaping.",
        "public_id": "019d595d-d899-702f-9dfe-fdc8c2d2c93e",
        "storage_key": "property/6737460151191761/019d595d-d899-702f-9dfe-fdc8c2d2c93e.webp",
        "width": 2048,
        "height": 1429
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10868005873123875347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-learning-tree-day-care",
      "poi_latitude": "28.0210803",
      "poi_longitude": "-97.0537166",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-729-0883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAcKP836zaYYRE1porMLp0pY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_0c2b4efa-d21f-48ce-ab2d-2d71423a4e51",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "ABC Learning Center",
      "poi_type": "Education",
      "poi_address": "1422 E Cedar St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.abclearningcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6508216622265770497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abc-learning-center",
      "poi_latitude": "28.032768",
      "poi_longitude": "-97.046549",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-1512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-3lhSHy0aYYRAaJxM4nUUVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_e99eefc8-1bc3-4507-b99f-3c8bec11e401",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Sacred Heart School",
      "poi_type": "Education",
      "poi_address": "213 S Church St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.shsrockport.org/apps/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7079021800947137017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacred-heart-school",
      "poi_latitude": "28.023144",
      "poi_longitude": "-97.0538984",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-729-2672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAEan6zaYYR-TmzWtK8PWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_3fc399c4-62e9-405d-abdc-49b3e2443eae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Aransas County Extension Agent",
      "poi_type": "Education",
      "poi_address": "611 E Mimosa St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://agrilifeextension.tamu.edu/counties/aransas-county/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14017200152677792586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-county-extension-agent",
      "poi_latitude": "28.0246265",
      "poi_longitude": "-97.0558439",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-0103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d595e-9e47-712d-9f62-bec247ccafd9",
        "storage_key": "property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwVmhgNSaIYRSjvpxUUZh8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_73bee68b-76a2-421f-be0f-ccc14735d4b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "204 S Austin St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-e1a0-748d-88a4-1e4429d55ded.webp",
      "poi_featured_image_media": {
        "alt_text": "Rockport Center for the Arts building exterior",
        "public_id": "019d595d-e1a0-748d-88a4-1e4429d55ded",
        "storage_key": "property/6737460151191761/019d595d-e1a0-748d-88a4-1e4429d55ded.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "http://www.rockportartcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9878775681610372647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-center-for-the-arts",
      "poi_latitude": "28.0227178",
      "poi_longitude": "-97.0505617",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-729-5519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0R7X4CzaYYRJ1YndiR2GIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ce437cab-afdc-4d66-bfb6-40e1d699eedb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Texas Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "1202 Navigation Cir, Rockport, TX 78382, USA",
      "poi_short_description": "From pirates to fishing to oil drilling, Gulf Coast history is told through exhibits & artifacts.",
      "poi_long_description": "From pirates to fishing to oil drilling, Gulf Coast history is told through exhibits & artifacts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595b-e440-728f-8ce5-5eaefeecb7eb.webp",
      "poi_featured_image_media": {
        "alt_text": "Lighthouse-style building with surrounding structures and landscaping.",
        "public_id": "019d595b-e440-728f-8ce5-5eaefeecb7eb",
        "storage_key": "property/6737460151191761/019d595b-e440-728f-8ce5-5eaefeecb7eb.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://texasmaritimemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17794021528320180622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-maritime-museum",
      "poi_latitude": "28.026322",
      "poi_longitude": "-97.048766",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-729-1271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f27-76ac-ac70-8ef90420c220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f27-76ac-ac70-8ef90420c220",
        "storage_key": "property/6737460151191761/019d076e-8f27-76ac-ac70-8ef90420c220.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0R7X4CzaYYRjoEtoU0Q8fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b8aa122d-58c9-4cf9-866d-9ee7c32a7f7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Fulton Mansion State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "317 Fulton Beach Rd, Rockport, TX 78382, USA",
      "poi_short_description": "An 1877 mansion known for its striking architecture, offering tours, historical education & events.",
      "poi_long_description": "An 1877 mansion known for its striking architecture, offering tours, historical education & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-604b-742d-9a5d-4eb723aaf822.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-604b-742d-9a5d-4eb723aaf822",
        "storage_key": "property/6737460151191761/019d076e-604b-742d-9a5d-4eb723aaf822.webp",
        "width": 1024,
        "height": 615
      },
      "poi_business_url": "http://www.visitfultonmansion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929651162930627556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fulton-mansion-state-historic-site",
      "poi_latitude": "28.0575757",
      "poi_longitude": "-97.0349521",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-729-0386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f27-76ac-ac70-8ef90420c220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f27-76ac-ac70-8ef90420c220",
        "storage_key": "property/6737460151191761/019d076e-8f27-76ac-ac70-8ef90420c220.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjT87xE60aYYR5EN26FBaSlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_e9feebcf-2878-4cb9-9fcc-b075bd0063b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport Beach Park",
      "poi_type": "Entertainment",
      "poi_address": "319 Broadway St, Rockport, TX 78382, USA",
      "poi_short_description": "Family-friendly spot with calm waters, a playground, pavilion & more.",
      "poi_long_description": "Family-friendly spot with calm waters, a playground, pavilion & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595c-1bb4-749b-a826-344148a26ea3.webp",
      "poi_featured_image_media": {
        "alt_text": "A thatched umbrella provides shade on a sandy beach with the ocean and clear blue sky in the background.",
        "public_id": "019d595c-1bb4-749b-a826-344148a26ea3",
        "storage_key": "property/6737460151191761/019d595c-1bb4-749b-a826-344148a26ea3.webp",
        "width": 3072,
        "height": 1730
      },
      "poi_business_url": "http://www.rockportbeach-texas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15007700107399948428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-beach-park",
      "poi_latitude": "28.0309567",
      "poi_longitude": "-97.0377305",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 361-729-6661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-92a2-7547-ba11-fca8c1307c92",
        "storage_key": "property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdvkXXe0aYYRjGgqxbsPRtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0c238580-cca5-4209-8726-d8dbb1e3fe7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Goose Island State Park",
      "poi_type": "Entertainment",
      "poi_address": "202 S Palmetto St, Rockport, TX 78382, USA",
      "poi_short_description": "Abundant recreational activities on 320 acres of marsh & prairie, with a tree dating 1,000+ years.",
      "poi_long_description": "Abundant recreational activities on 320 acres of marsh & prairie, with a tree dating 1,000+ years.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-efa9-758b-84b2-cb6c48976079.webp",
      "poi_featured_image_media": {
        "alt_text": "Large oak tree with sprawling branches and green grass field.",
        "public_id": "019d595d-efa9-758b-84b2-cb6c48976079",
        "storage_key": "property/6737460151191761/019d595d-efa9-758b-84b2-cb6c48976079.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/goose-island",
      "poi_directions_map_url": "https://maps.google.com/?cid=5645286817377101663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goose-island-state-park",
      "poi_latitude": "28.1341516",
      "poi_longitude": "-96.9842456",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 361-729-2858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-92a2-7547-ba11-fca8c1307c92",
        "storage_key": "property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrY6I38HJaYYRXyf1THMWWE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_8d71b9ff-54c2-4174-b76c-773a895f8713",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport Aquarium Education Center",
      "poi_type": "Entertainment",
      "poi_address": "706 Navigation Cir, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-ef4b-778f-a8d2-9fc3a5aaac55.webp",
      "poi_featured_image_media": {
        "alt_text": "Boy feeding seagulls while man fishes by the water near a building",
        "public_id": "019d595d-ef4b-778f-a8d2-9fc3a5aaac55",
        "storage_key": "property/6737460151191761/019d595d-ef4b-778f-a8d2-9fc3a5aaac55.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14134813070028602784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-aquarium-education-center",
      "poi_latitude": "28.0243276",
      "poi_longitude": "-97.0474669",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZTOEY4CzaYYRoH2aBZnxKMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_39d264a6-999a-47f3-b417-4f7655cbda24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Aransas National Wildlife Refuge",
      "poi_type": "Entertainment",
      "poi_address": "1 Wildlife Circle, Austwell, TX 77950, USA",
      "poi_short_description": "Sprawling refuge offering a natural setting for hiking, fishing, hunting & wildlife watching.",
      "poi_long_description": "Sprawling refuge offering a natural setting for hiking, fishing, hunting & wildlife watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-e588-7564-9c76-b272c79c9382.webp",
      "poi_featured_image_media": {
        "alt_text": "Expansive view of a coastal marshland with winding waterways and distant ocean under a cloudy sky.",
        "public_id": "019d595d-e588-7564-9c76-b272c79c9382",
        "storage_key": "property/6737460151191761/019d595d-e588-7564-9c76-b272c79c9382.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.fws.gov/refuge/Aransas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12282231641036942607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-national-wildlife-refuge",
      "poi_latitude": "28.3086558",
      "poi_longitude": "-96.8043026",
      "poi_miles_from_property": "33.8",
      "poi_walking_minutes": "12 hours 10 mins",
      "poi_biking_minutes": "3 hours 3 mins",
      "poi_driving_minutes": "42 mins",
      "poi_business_phone": "+1 361-349-1181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-92a2-7547-ba11-fca8c1307c92",
        "storage_key": "property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHapzF9jFaYYRD-0RfZpAc6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_805bca2b-772d-4278-b573-e31cf7692428",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Leonabelle Turnbull Birding Center",
      "poi_type": "Entertainment",
      "poi_address": "1356 Ross Ave, Port Aransas, TX 78373, USA",
      "poi_short_description": "Observation area for birds, alligators & fish, featuring a boardwalk & tower with panoramic views.",
      "poi_long_description": "Observation area for birds, alligators & fish, featuring a boardwalk & tower with panoramic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-e32f-73d9-a600-0ea24441008a.webp",
      "poi_featured_image_media": {
        "alt_text": "People on a boardwalk overlooking a marsh with a bird watching tower.",
        "public_id": "019d595d-e32f-73d9-a600-0ea24441008a",
        "storage_key": "property/6737460151191761/019d595d-e32f-73d9-a600-0ea24441008a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://cityofportaransas.org/departments/parks-and-recreation/nature-preserve/birding-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17808724800613476167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leonabelle-turnbull-birding-center",
      "poi_latitude": "27.8272791",
      "poi_longitude": "-97.0783761",
      "poi_miles_from_property": "20.8",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "50 mins",
      "poi_business_phone": "+1 361-749-4158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4JxhFqraYYRR2dB-9lMJfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dd226bfa-2d96-4170-8be1-823302ecb3dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport Little Theatre",
      "poi_type": "Entertainment",
      "poi_address": "99 N Austin St, Rockport, TX 78382, USA",
      "poi_short_description": "Charming theater with staggered seating and concessions hosting local talent.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-093b-775c-beb0-5234a01fa666.webp",
      "poi_featured_image_media": {
        "alt_text": "A colorful photo booth cutout featuring cartoon characters in formal attire against a red curtain.",
        "public_id": "019d595e-093b-775c-beb0-5234a01fa666",
        "storage_key": "property/6737460151191761/019d595e-093b-775c-beb0-5234a01fa666.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.rockportlittletheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11840567270742678340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-little-theatre",
      "poi_latitude": "28.0238475",
      "poi_longitude": "-97.0509414",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-450-1465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAUQlq0aYYRRNu73zIlUqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_00cd5679-a330-4832-8fa2-e75c4c3a6967",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "ER 24/7 Rockport, a department of Corpus Christi Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Enterprise Blvd, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-efb6-711e-b12b-00f0dccad070.webp",
      "poi_featured_image_media": {
        "alt_text": "Building with patient drop-off overhang",
        "public_id": "019d595d-efb6-711e-b12b-00f0dccad070",
        "storage_key": "property/6737460151191761/019d595d-efb6-711e-b12b-00f0dccad070.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.ccmedicalcenter.com/locations/er-24-7-rockport?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17486584589488906612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "er-247-rockport-a-department-of-corpus-christi-medical-center",
      "poi_latitude": "28.0411327",
      "poi_longitude": "-97.0575746",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 361-727-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxbJJQm1aYYRdGFORwnUrPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_20da696e-66f6-4fde-ac07-71e01d77eb6c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "StatCare Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2102 FM2165, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-093f-71d8-9db2-9d628d7f37c4.webp",
      "poi_featured_image_media": {
        "alt_text": "STAT 2 CARE Urgent Care building exterior with signage.",
        "public_id": "019d595e-093f-71d8-9db2-9d628d7f37c4",
        "storage_key": "property/6737460151191761/019d595e-093f-71d8-9db2-9d628d7f37c4.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.mystatcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17597162951259349281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statcare-urgent-care",
      "poi_latitude": "28.0515831",
      "poi_longitude": "-97.0669169",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 361-556-5770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeLxIMu1aYYRIWF6bHiuNfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_e5b071b8-d495-4750-afd7-461b479e3468",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1409 Hwy 35 N Business, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595d-b1a6-772c-93a4-2f6db2e27bb1.webp",
      "poi_featured_image_media": {
        "alt_text": "HEB Pharmacy building with drive-thru lanes and awnings.",
        "public_id": "019d595d-b1a6-772c-93a4-2f6db2e27bb1",
        "storage_key": "property/6737460151191761/019d595d-b1a6-772c-93a4-2f6db2e27bb1.webp",
        "width": 1289,
        "height": 710
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=5396727113005842595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "28.0384016",
      "poi_longitude": "-97.0437857",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-0530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e55-7156-8115-3182afef533d.webp",
      "poi_map_icon_media": {
        "alt_text": "Pharmacy symbol",
        "public_id": "019d595e-9e55-7156-8115-3182afef533d",
        "storage_key": "property/6737460151191761/019d595e-9e55-7156-8115-3182afef533d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2dlGMhMaIYRo8BuWLcG5Uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3bccfdff-8606-4b72-823d-1fa2d16e5354",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1309 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-1b2a-742a-963f-b7aca60547a1.webp",
      "poi_featured_image_media": {
        "alt_text": "A group of six pharmacists in a pharmacy setting, all smiling.",
        "public_id": "019d595e-1b2a-742a-963f-b7aca60547a1",
        "storage_key": "property/6737460151191761/019d595e-1b2a-742a-963f-b7aca60547a1.webp",
        "width": 1446,
        "height": 660
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1309+highway+35+n-rockport-tx-78382/id=9205",
      "poi_directions_map_url": "https://maps.google.com/?cid=12623238929882287806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "28.0372332",
      "poi_longitude": "-97.0431773",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-8706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e55-7156-8115-3182afef533d.webp",
      "poi_map_icon_media": {
        "alt_text": "Pharmacy symbol",
        "public_id": "019d595e-9e55-7156-8115-3182afef533d",
        "storage_key": "property/6737460151191761/019d595e-9e55-7156-8115-3182afef533d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl3E_raC1aYYRvg6ECu3ALq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_aaecff81-5f63-401e-9711-e5ba02984509",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Fit Lab Rockport",
      "poi_type": "Health and Wellness",
      "poi_address": "916 Hwy 35 S, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-769d-775b-a034-39187fc6b133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-769d-775b-a034-39187fc6b133",
        "storage_key": "property/6737460151191761/019d076e-769d-775b-a034-39187fc6b133.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.fitlabrockport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17695387880071179388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-lab-rockport",
      "poi_latitude": "28.0174013",
      "poi_longitude": "-97.0608472",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 361-450-8269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfffNf1W1aYYRfCxl0oWlkvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c559bef5-cdf6-49c8-a790-9df3ce7d3722",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "The Pilates Place - of Rockport",
      "poi_type": "Health and Wellness",
      "poi_address": "810 Henderson St Ste 4, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-1f57-71e8-9ff4-d5ef73cfa8f8.webp",
      "poi_featured_image_media": {
        "alt_text": "Pilates reformer machine and fitness equipment in a gym.",
        "public_id": "019d595e-1f57-71e8-9ff4-d5ef73cfa8f8",
        "storage_key": "property/6737460151191761/019d595e-1f57-71e8-9ff4-d5ef73cfa8f8.webp",
        "width": 2119,
        "height": 1192
      },
      "poi_business_url": "https://www.pilatesplaceofrockport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18198270839821191306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pilates-place---of-rockport",
      "poi_latitude": "28.0562288",
      "poi_longitude": "-97.0425261",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-450-0190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCzLYR7i1aYYRikjkBek-jfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cb19a1f1-c44c-4eff-8bcc-55d9d9cb095a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Sandy Soul Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "1005 E Main St #3, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-25fd-762b-9a47-ab793471f542.webp",
      "poi_featured_image_media": {
        "alt_text": "Woman in yoga attire meditating in a yoga studio with mats and blocks laid out.",
        "public_id": "019d595e-25fd-762b-9a47-ab793471f542",
        "storage_key": "property/6737460151191761/019d595e-25fd-762b-9a47-ab793471f542.webp",
        "width": 3000,
        "height": 2182
      },
      "poi_business_url": "https://www.sandysoulyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13856328942605766917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sandy-soul-yoga",
      "poi_latitude": "28.021358",
      "poi_longitude": "-97.0519028",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-864-5955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf8b9VRazaYYRBRH7YsKRS8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_b0446a9b-f7c6-4c8a-aa66-4c1076d92234",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Fitness Court at Memorial Park",
      "poi_type": "Health and Wellness",
      "poi_address": "1702 FM2165, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-2b14-7545-a998-3964634be6dc.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor fitness park with blue matting and exercise equipment.",
        "public_id": "019d595e-2b14-7545-a998-3964634be6dc",
        "storage_key": "property/6737460151191761/019d595e-2b14-7545-a998-3964634be6dc.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.nationalfitnesscampaign.com/fitness-court",
      "poi_directions_map_url": "https://maps.google.com/?cid=15014060796365397000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-court-at-memorial-park",
      "poi_latitude": "28.0418961",
      "poi_longitude": "-97.0603355",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNSnH7uy1aYYRCFx6E7-oXNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c25ae477-71bf-41c1-8675-82dbbcc6f435",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Memorial Park, Rockport, TX 78382, USA",
      "poi_short_description": "Park featuring a skatepark, baseball diamonds and picnic tables, plus a dog park and a pond.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595c-2196-748a-90ec-3fec8d9a7b9c.webp",
      "poi_featured_image_media": {
        "alt_text": "Park area with mature trees, picnic tables, and grills.",
        "public_id": "019d595c-2196-748a-90ec-3fec8d9a7b9c",
        "storage_key": "property/6737460151191761/019d595c-2196-748a-90ec-3fec8d9a7b9c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4304393212245953194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "28.0398543",
      "poi_longitude": "-97.060994",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-92a2-7547-ba11-fca8c1307c92",
        "storage_key": "property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEff7zlS1aYYRqsqFJdJGvDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d43cca07-3e53-44ed-8934-96e22a68173c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Connie Hagar Cottage Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1429 S Church St, Rockport, TX 78382, USA",
      "poi_short_description": "Small birding destination with butterflies and trails, plus a serene atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-2c5a-77bc-9ce3-42b32d900063.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden observation deck and walking path in a grassy field with houses and trees in the background.",
        "public_id": "019d595e-2c5a-77bc-9ce3-42b32d900063",
        "storage_key": "property/6737460151191761/019d595e-2c5a-77bc-9ce3-42b32d900063.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9046480011467442761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "connie-hagar-cottage-sanctuary",
      "poi_latitude": "28.0099097",
      "poi_longitude": "-97.0593797",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 361-749-3153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-92a2-7547-ba11-fca8c1307c92",
        "storage_key": "property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUefx3GzaYYRSUow36ONi30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_dd1e3021-2250-45c4-b0ef-91b08ee970b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport Rookery",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1401 Broadway St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-3e39-759a-b9c6-fc3e6e7ee6f8.webp",
      "poi_featured_image_media": {
        "alt_text": "Great blue heron in a nest in a tree against a clear blue sky.",
        "public_id": "019d595e-3e39-759a-b9c6-fc3e6e7ee6f8",
        "storage_key": "property/6737460151191761/019d595e-3e39-759a-b9c6-fc3e6e7ee6f8.webp",
        "width": 3072,
        "height": 2049
      },
      "poi_business_url": "https://www.rockportfulton.com/bent-oaks-rookery-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2208538033205019257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-rookery",
      "poi_latitude": "28.0381275",
      "poi_longitude": "-97.0409683",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-1136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLzaKuu-1aYYReQIgzqNNph4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3552dd0d-87be-4225-b905-3d7c96c22771",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Tule Creek Hike And Bike Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2491 Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "Paved 1-mile trail for hiking, biking and running.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-2e2d-7788-82d1-97824e75a3d9.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk and bridge over a small river surrounded by trees and grass under a clear blue sky.",
        "public_id": "019d595e-2e2d-7788-82d1-97824e75a3d9",
        "storage_key": "property/6737460151191761/019d595e-2e2d-7788-82d1-97824e75a3d9.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://tule-trail.keeq.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12938343273668466818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tule-creek-hike-and-bike-trail",
      "poi_latitude": "28.0501404",
      "poi_longitude": "-97.0429553",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVNelF20aYYRgtgSOag6jrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_7b5e5e6d-7a70-43b5-82e0-6d3b3f488b56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Compass Rose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "811 Business Hwy 35 N, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-33ae-7145-9cad-2429cfcb3146.webp",
      "poi_featured_image_media": {
        "alt_text": "Compass Rose Park monument sign with a heron and tree logo.",
        "public_id": "019d595e-33ae-7145-9cad-2429cfcb3146",
        "storage_key": "property/6737460151191761/019d595e-33ae-7145-9cad-2429cfcb3146.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12789758386128865350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "compass-rose-park",
      "poi_latitude": "28.030661",
      "poi_longitude": "-97.0470928",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-92a2-7547-ba11-fca8c1307c92",
        "storage_key": "property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8QFCh360aYYRRshIOH1ZfrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1c3d2f80-745b-43bc-8a2d-f9e9cafb6a6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Zachary Taylor Arboretum Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "702 S Pearl St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-546b-7639-aae0-64c09b1bb326.webp",
      "poi_featured_image_media": {
        "alt_text": "White gazebo with white picket fence and park hours sign.",
        "public_id": "019d595e-546b-7639-aae0-64c09b1bb326",
        "storage_key": "property/6737460151191761/019d595e-546b-7639-aae0-64c09b1bb326.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11776786260570766505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zachary-taylor-arboretum-park",
      "poi_latitude": "28.019117",
      "poi_longitude": "-97.055946",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-92a2-7547-ba11-fca8c1307c92",
        "storage_key": "property/6737460151191761/019d076e-92a2-7547-ba11-fca8c1307c92.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyZzGHc-zaYYRqXwFObWMb6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5b2ef179-35a7-44d0-b779-88e1100dce0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Aransas County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "421 John D Wendell Rd, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595c-4b15-76ef-bd56-cd5aedcf126a.webp",
      "poi_featured_image_media": {
        "alt_text": "A woman in a blue shirt and baseball cap stands next to a small plane with children inside.",
        "public_id": "019d595c-4b15-76ef-bd56-cd5aedcf126a",
        "storage_key": "property/6737460151191761/019d595c-4b15-76ef-bd56-cd5aedcf126a.webp",
        "width": 2303,
        "height": 3072
      },
      "poi_business_url": "https://www.aransascountyairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7605397564980246963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-county-airport",
      "poi_latitude": "28.086773",
      "poi_longitude": "-97.044556",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-0141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-93ea-738e-81b9-454d8a182cc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-93ea-738e-81b9-454d8a182cc4",
        "storage_key": "property/6737460151191761/019d076e-93ea-738e-81b9-454d8a182cc4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2RiQtwm1aYYRs7lETMrMi2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_75dd261c-510e-4e31-8b72-b25d2ef77e1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Port Aransas Ferry Landing",
      "poi_type": "Transportation & Transit",
      "poi_address": "619 W Cotter Ave, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-5866-776b-8942-3bda9066c3f3.webp",
      "poi_featured_image_media": {
        "alt_text": "The Joseph F. Weber ferryboat carrying cars across the water on a clear day.",
        "public_id": "019d595e-5866-776b-8942-3bda9066c3f3",
        "storage_key": "property/6737460151191761/019d595e-5866-776b-8942-3bda9066c3f3.webp",
        "width": 1600,
        "height": 1200
      },
      "poi_business_url": "https://www.portaransas.org/plan/transportation/ferry/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17519353593087414393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-aransas-ferry-landing",
      "poi_latitude": "27.8396272",
      "poi_longitude": "-97.0690363",
      "poi_miles_from_property": "19.5",
      "poi_walking_minutes": "7 hours 6 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "45 mins",
      "poi_business_phone": "+1 361-749-5494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d595e-9e47-712d-9f62-bec247ccafd9",
        "storage_key": "property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0RQ2n2raYYReVBwekU_IfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_a1b16bff-efb8-421c-8d2c-dfc49db6bab1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Aransas Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "Texas 361, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-7175-714e-a5cb-72c45cf8dc20.webp",
      "poi_featured_image_media": {
        "alt_text": "Ferry at sunset with water and docks.",
        "public_id": "019d595e-7175-714e-a5cb-72c45cf8dc20",
        "storage_key": "property/6737460151191761/019d595e-7175-714e-a5cb-72c45cf8dc20.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8124132343458150151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-pass",
      "poi_latitude": "27.8441041",
      "poi_longitude": "-97.07048",
      "poi_miles_from_property": "19.2",
      "poi_walking_minutes": "6 hours 57 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5cGNsJisaYYRB7cVqFK3vnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_terminal"
    },
    {
      "id": "custom_e5389b73-e10b-493e-b832-01c3a5d93cb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Greyhound",
      "poi_type": "Transportation & Transit",
      "poi_address": "2902 Hwy 35 N Bypass, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-5d12-7670-a0d3-02117d99191f.webp",
      "poi_featured_image_media": {
        "alt_text": "Greyhound logo with a dog running and the word Greyhound.",
        "public_id": "019d595e-5d12-7670-a0d3-02117d99191f",
        "storage_key": "property/6737460151191761/019d595e-5d12-7670-a0d3-02117d99191f.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "http://locations.greyhound.com/bus-stations/US/Rockport/bus-station/bus-station-684101?utm_source=google&utm_medium=distrib&utm_campaign=google-distrib",
      "poi_directions_map_url": "https://maps.google.com/?cid=12591213620646532058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound",
      "poi_latitude": "28.0573735",
      "poi_longitude": "-97.0408344",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAV5VRaW0aYYR2lOyrRP6vK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_b8c0b036-bbba-4084-87b9-82fb298a8ce8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Gregory Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Gregory, TX 78359, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12050609337613431342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gregory-park--ride",
      "poi_latitude": "27.9147903",
      "poi_longitude": "-97.2955345",
      "poi_miles_from_property": "20.9",
      "poi_walking_minutes": "7 hours 34 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI6j_tc1aaIYRLjJ0f1hdPKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_9b9043f6-fc5b-430a-9d68-929f2855b7ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport School & Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "619 N Live Oak St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-7172-7078-b8f3-471d30844659.webp",
      "poi_featured_image_media": {
        "alt_text": "Rockport School building exterior with entrance and windows.",
        "public_id": "019d595e-7172-7078-b8f3-471d30844659",
        "storage_key": "property/6737460151191761/019d595e-7172-7078-b8f3-471d30844659.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "http://www.acisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12294740353778318903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-school--administration",
      "poi_latitude": "28.0286663",
      "poi_longitude": "-97.0529182",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-790-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8e1a-711a-ae93-bb01e4f56d6e",
        "storage_key": "property/6737460151191761/019d076e-8e1a-711a-ae93-bb01e4f56d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGbNPG4G0aYYRN_6dIDaxn6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_5583a85c-66db-45b9-87e7-9afabb3e87f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Aransas County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "308 N Live Oak St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-717a-746c-9a36-c359b8ed4498.webp",
      "poi_featured_image_media": {
        "alt_text": "Aransas County Court House building exterior with American and Texas flags flying.",
        "public_id": "019d595e-717a-746c-9a36-c359b8ed4498",
        "storage_key": "property/6737460151191761/019d595e-717a-746c-9a36-c359b8ed4498.webp",
        "width": 826,
        "height": 550
      },
      "poi_business_url": "http://www.aransascountytx.gov/countyjudge/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18399252518280845626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-county-courthouse",
      "poi_latitude": "28.025958",
      "poi_longitude": "-97.052167",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-790-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d595e-9e47-712d-9f62-bec247ccafd9",
        "storage_key": "property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7T9vzIG0aYYROlnXlK5GV_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_bc0a5d79-d5be-4912-a7d6-1a5eb958be21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "City of Rockport Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "402 E Laurel St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cityofrockport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9002548517994331798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-rockport-offices",
      "poi_latitude": "28.0284866",
      "poi_longitude": "-97.0564579",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-729-2213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d595e-9e47-712d-9f62-bec247ccafd9",
        "storage_key": "property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxySULnyzaYYRln5F-C1673w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_ccbed941-faba-44ce-af9d-5673430b2f11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Rockport Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "714 E Concho St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-7b28-7681-91ab-b1dd94225e52.webp",
      "poi_featured_image_media": {
        "alt_text": "Public Safety Center entrance with flags at dusk",
        "public_id": "019d595e-7b28-7681-91ab-b1dd94225e52",
        "storage_key": "property/6737460151191761/019d595e-7b28-7681-91ab-b1dd94225e52.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.cityofrockport.com/84/Police",
      "poi_directions_map_url": "https://maps.google.com/?cid=11302891836452223069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-police-department",
      "poi_latitude": "28.0257571",
      "poi_longitude": "-97.0539614",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-729-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d595e-9e47-712d-9f62-bec247ccafd9",
        "storage_key": "property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXmt5YG0aYYRXbhlbj3w25w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_7cd03a16-7dc3-47a4-9b6a-f4adc09d1e54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Aransas County Detention Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "MAILTO: 2840, Highway 35 North Bypass, 811 E Concho St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.aransascounty.org/detentioncenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3907278121169329082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-county-detention-center",
      "poi_latitude": "28.0253448",
      "poi_longitude": "-97.0531005",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-790-0168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d595e-9e47-712d-9f62-bec247ccafd9",
        "storage_key": "property/6737460151191761/019d595e-9e47-712d-9f62-bec247ccafd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzJoUn6zaYYRuhv04r9wOTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d2a22ac4-8eaa-4585-9287-b97597b6e1d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "poi_name": "Aransas County Council On Aging",
      "poi_type": "Major Employers & Offices",
      "poi_address": "912 S Church St, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.aransascounty.org/councilaging/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6477667686523355164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-county-council-on-aging",
      "poi_latitude": "28.015925",
      "poi_longitude": "-97.05605",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 361-729-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-8f4e-72bd-8148-39e2b4bcad63",
        "storage_key": "property/6737460151191761/019d076e-8f4e-72bd-8148-39e2b4bcad63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9fv-MnqzaYYRHEBA1HBM5Vk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    }
  ],
  "office_hours": [
    {
      "id": "custom_5fb0828b-5745-4a2d-951a-cdabff00c117",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f69d077a-e40e-407a-9b35-5967caff397a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b18294c9-75d4-429b-8e5e-dda2f42b6d22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d3ccff8c-b28b-4f7b-ab95-e35ef1457e15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_521a6c1a-3c4d-4723-b132-89b131e981e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_86a52a85-757e-4e02-8c83-e9a76ba87758",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0855d139-cde7-4b77-a3e0-9f8c93f8eef1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Application process and move-in was best I have had with an apartment community. The apartment is so lovely and just what I was looking for. Would highly recommend this community. Employees in the office are awesome!",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_ad7d77f7-19a8-4190-9b32-f273371f66af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Pearl Point community feels like your on vacation at a resort. The pool, gym, and the grounds are beautiful! The staff is super friendly and helpful. Our dogs even love it! I highly recommend this awesome place!!",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_2f02feed-dd01-4953-8c1c-7310e220fea4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Pearl Point fits its name .\nIts a special gem in an coastal city. \nAll amenities anyone  could ask for and need all wrapped up into a nice peaceful community",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_156bca18-132d-4f0d-8123-514381d7011c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "This is an outstanding apartment community!  The floor plans have been well planned and laid out.  The amenities are great.  The staff is polite, friendly, professional, and knowledgeable.  The property is well maintained.  It is quiet and clean!  Its also a great place for pet owners.  There are two huge dog parks and lots of grass and walking areas around the complex.  It is also a gated community!  Its a great place to live!",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_037f3f04-fabd-497a-bfd3-c350ca84f99f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "4.0",
      "name": "",
      "text": "Great New Community. Management and maintenance staff is fantastic and always on the ball.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_6fe6929b-608d-4ca2-9f25-f9168a7de685",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "From the leasing office to maintenance,  Pearl Point has a great team who make living here a wonderful place to call home.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_8266ae06-c3a7-4ab1-8e01-792916b59e03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "4.0",
      "name": "",
      "text": "Wonderful place to live, friendly staff and great people to live around!",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_c86f2dba-8db3-40ee-901e-d766d795a26d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Our experience at Pearl Point has been absolutely delightful! Attentive, friendly staff, beautiful apartments and grounds, and very pet-friendly.  Truly Rockports newest gem!",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_26ae2edc-2a37-4970-8b2e-8ea852962be5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Pearl Point is a wonderful place to live. Beautiful and extremely safe. The amenities are amazing.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_e56bd6f1-d983-495d-a7dd-76a5fda061bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "PEARL POINT is an extremely beautiful, well kept and peaceful community. My kids get off the bus and are always greeted as they walk in, they are even able to have snacks in drinks from the offices kitchen area. I honestly have not seen this at another apartment community. Everything is so beautiful that I feel like I live at a resort. The office staff was extremely accommodating and friendly when I was moving in. It could not be better located and is amidst a lot of shopping, restaurants, transportation and schools. It offered amenities that most communities did not. I'm proud to call this place HOME.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_28e73fc4-cbcf-46cd-bb0c-3c6434652ac3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "4.0",
      "name": "",
      "text": "Maintenance has always been timely and courtesy when completing request.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_f66aac93-54c5-492a-824f-abe1c64633a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Great place, everything is so lovely. Upgraded everything, brand new everything else, and the price is fair.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_b12a6136-90d4-4900-b5df-c64dc9ab23e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Pearl Point Apartments are perfectly located. Shopping and restaurants are close and excellent. Cathie Adams",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_c5c327ff-de93-433a-be9c-a3fd1a30a86c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Pearl point is a well kept facility. Safety is a selling point. All personnel are well qualified. I am happy to be living here.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_2f604f23-0f7d-4c49-9fc0-ca21396c91c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Appreciate the safety around property especially the lighting.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_82774e5a-c7f9-4bfa-bac6-8aac7b6ba8d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "I've only been at Pearl Point a couple of weeks but I have to say it's been quite enjoyable so far. I love my apt and all the amenities. The peaceful and tranquility surroundings makes it much more pleasant.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_6e797534-7679-4f1c-b471-fdc4e6129b3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Pearl Point is truly as gorgeous as a Pearl. And the staff are always friendly. The maintenance has been excellent too.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_b604c9ee-3c8b-4237-8bac-4c89f2df07e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "This is a terrific Greystar property with a great beach town vibe, a quality front office and maintenance staff, really nice residents, and wonderful amenities! We have been gone for a couple of weeks and really miss the place and can’t wait to get back home! We are very pleased with our choice in Rockport and Greystar, as usual, continues to impress! They really understand what it takes as a property management company to run an upscale property from both a visual and customer service standpoint - they just get it better than most and it shows!",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_da889f1e-2e72-42b8-a75a-4d1ffe5edc5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "Rose was my leasing agent and I found her to be excellent and always answered my questions in a timely manner.  The apartment I moved into was very clean and freshly painted.  The grounds and pool area are also clean and well maintained.  The complex is also very quiet.  I have only been living here for 2 weeks but so far - a good experience.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_39b050a2-cea4-4c52-a4be-ea8039ad8cd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "If you love your amenities and a safe place to live this would be the place to come",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_d9178eb4-ccc0-4d53-8463-8199c77df8db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "rating": "5.0",
      "name": "",
      "text": "I love living here! Clean, calm, safe, friendly, very reasonably priced. I hardly ever hear through walls or ceiling. People here are kind and respectful of each other. All the employees here go the extra mile to take care of residents and property. I call this my retirement resort, even though it is very family friendly for folks with children.  It really does feel more like a home than just an apartment. ",
      "date": "",
      "title": "Wonderful! "
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_24ad58fd75e86f2e0c3e00cb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Discover the Pearl Point apartments with this immersive walkthrough virtual tour experience with LCP Media",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-78aa-723a-bc0f-831c490c1e39.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the community lounge area with kitchen and seating.",
        "public_id": "019d076f-78aa-723a-bc0f-831c490c1e39",
        "storage_key": "property/6737460151191761/019d076f-78aa-723a-bc0f-831c490c1e39.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Pearl Point Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6661d6a0d5c3d22e3c2b931d"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019910d3-b5d4-70d9-854d-82a9772cd23e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Pearl Point property website",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761"
    },
    {
      "lead_collector_id": "019910d3-b64b-730d-8cba-5e07ee7b0bd1",
      "lead_source": "FACEBOOK_ADS",
      "name": "Pearl Point facebook ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761"
    },
    {
      "lead_collector_id": "019910d3-b6bd-737f-8a73-9af331b2c25e",
      "lead_source": "LANDING_PAGE",
      "name": "Pearl Point landing page",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-rockport-tx",
      "search_query": "luxury apartments with pool in rockport tx",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Rockport, TX",
      "h2_subtitle": "Discover modern luxury with a pool at Pearl Point in Rockport. Dive into upscale living with premium amenities right in Rockport, TX.",
      "page_copy": "Experience the unique blend of luxury and comfort at Pearl Point, where our luxury apartments with pool in Rockport, TX, redefine upscale living. Residents can enjoy a refreshing dip any time they desire, as our stunning pool area is the perfect spot to unwind and relax. The community design emphasizes both convenience and style, making every moment feel indulgent.\n\nLocated in the charming Rockport/North Aransas County, Pearl Point offers more than just a beautiful pool. Our spacious one, two, or three-bedroom apartments feature modern kitchens with granite countertops, walk-in closets, and ceiling fans, ensuring a comfortable living experience. You’ll also enjoy access to a state-of-the-art fitness center and pet-friendly spaces, providing everything you need to embrace a luxurious lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Rockport, TX",
      "seo_description": "Discover Pearl Point's luxury apartments with a pool in Rockport, TX. Enjoy upscale living with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-pet-play-area-aransas-county",
      "search_query": "dog friendly apartments with pet play area aransas county",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Aransas County",
      "h2_subtitle": "Enjoy pet-friendly living at Pearl Point in Aransas County. Our pet play area makes these apartments perfect for dog lovers.",
      "page_copy": "Pearl Point Apartments in Rockport, nestled within Aransas County, offer a haven for pet lovers searching for dog friendly apartments with pet play area. Our community embraces pets as family, providing dedicated spaces where both owners and their dogs can socialize and exercise. Our pet play area is designed to be a space where dogs can frolic freely, ensuring a joyful routine for every pet owner.\n\nComplementing the pet-friendly amenities, Pearl Point also offers spacious living options in one, two, or three-bedroom layouts. Modern comforts like granite countertops, walk-in closets, and ceiling fans are standard, making both humans and their furry companions feel right at home. Embrace a lifestyle where comfort and pet-friendly facilities come together harmoniously.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Aransas County",
      "seo_description": "Explore Pearl Point's dog-friendly apartments in Aransas County with a pet play area, along with modern amenities for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "apartments-in-unit-washer-dryer-rockport-tx",
      "search_query": "apartments with in-unit washer dryer rockport tx",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer in Rockport",
      "h2_subtitle": "Pearl Point in Rockport offers apartments equipped with in-unit washer and dryer. Enjoy the convenience of modern living in a great location.",
      "page_copy": "Upgrade your lifestyle at Pearl Point in Rockport, TX, where our apartments with in-unit washer dryer provide the ultimate convenience. Enjoy the modern amenities and thoughtful design tailored to meet the needs of today's busy lifestyles. With our in-unit laundry facilities, say goodbye to tedious trips to the laundromat and embrace hassle-free living.\n\nLocated in the scenic Rockport/North Aransas County, Pearl Point features a selection of spacious one, two, or three-bedroom apartments complemented by luxurious amenities such as granite countertops and walk-in closets. Beyond in-unit conveniences, residents can enjoy the benefits of a fully equipped fitness center, a sparkling pool, and pet-friendly spaces, making this the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer Dryer in Rockport",
      "seo_description": "Discover Pearl Point's modern apartments in Rockport, TX, featuring in-unit washer dryer facilities and upscale amenities for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "modern-apartments-air-conditioning-rockport-north-aransas",
      "search_query": "modern apartments with air conditioning rockport north aransas county",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Air Conditioning",
      "h2_subtitle": "Experience comfort at Pearl Point in Rockport. Our modern apartments with air conditioning and upscale amenities await you.",
      "page_copy": "Welcome to Pearl Point, where modern living meets exceptional comfort in Rockport/North Aransas County. Our modern apartments with air conditioning ensure a cool retreat from the Texas heat. Each of our one, two, or three-bedroom floor plans is designed with your comfort in mind, featuring high-end finishes and thoughtful layouts.\n\nNestled in a vibrant community, Pearl Point offers more than just climate control. Residents have access to a host of upscale amenities, including a state-of-the-art fitness center, sparkling pool, and pet-friendly spaces. Granite countertops and walk-in closets add a touch of luxury to daily life, allowing you to enjoy a modern lifestyle with every convenience at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Air Conditioning",
      "seo_description": "Discover Pearl Point's modern apartments in Rockport/North Aransas County with air conditioning and premium amenities for a comfortable living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "spacious-apartments-fitness-center-near-78382",
      "search_query": "spacious apartments with fitness center near 78382",
      "category": "Amenity",
      "h1_title": "Spacious Apartments Near 78382",
      "h2_subtitle": "Find your home at Pearl Point near 78382, offering spacious apartments with a fully equipped fitness center for an active lifestyle.",
      "page_copy": "Discover the lifestyle you deserve at Pearl Point, where spacious apartments with fitness center amenities await near the 78382 area. Offering one, two, and three-bedroom layouts, our apartments are designed to provide ample space and comfort, perfect for those who appreciate modern living.\n\nLocated in the heart of Rockport/North Aransas County, Pearl Point features a state-of-the-art fitness center that caters to all your workout needs. Beyond fitness, enjoy the convenience of amenities like a shimmering pool and pet-friendly areas. With granite countertops and walk-in closets in each unit, our community ensures you have everything you need for a stylish and comfortable life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments Near 78382",
      "seo_description": "Explore Pearl Point's spacious apartments near 78382, complete with a fitness center and modern amenities for a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-rockport-tx",
      "search_query": "1 bedroom apartments rockport tx",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Rockport, TX",
      "h2_subtitle": "Discover the charm of Rockport with our refined 1 bedroom apartments. Enjoy modern amenities and a welcoming community at Pearl Point.",
      "page_copy": "Experience the welcoming community of Pearl Point in Rockport, TX, where our thoughtfully designed 1 bedroom apartments offer the perfect blend of comfort and style. Ideal for singles or couples seeking a modern living space, each apartment features upscale amenities, including granite countertops and walk-in closets, ensuring a luxurious lifestyle.\n\nSituated in the scenic Rockport/North Aransas County, living at Pearl Point means having access to both tranquility and a range of conveniences. Residents benefit from a fitness center, a pristine pool, and pet-friendly environments, all within a short distance of local attractions and the serene TX coastline.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Rockport, TX",
      "seo_description": "Explore Pearl Point's 1 bedroom apartments in Rockport, TX, offering modern amenities and community features for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-aransas-county",
      "search_query": "2 bedroom apartments aransas county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Aransas County",
      "h2_subtitle": "Explore Pearl Point's 2 bedroom apartments in Aransas County. Enjoy spacious living with modern amenities in a convenient location.",
      "page_copy": "Welcome to Pearl Point, offering exceptional 2 bedroom apartments nestled within the heart of Aransas County. These thoughtfully designed living spaces provide the ideal blend of comfort and style, featuring granite countertops, walk-in closets, and ceiling fans in every unit. Perfect for roommates or small families, our apartments offer the room you need to live comfortably.\n\nLocated in the scenic Rockport/North Aransas County area, Pearl Point provides more than just spacious living. Take advantage of our top-tier amenities, including a cutting-edge fitness center and a sparkling swimming pool. With convenience and leisure at your doorstep, experience a lifestyle that’s both sophisticated and serene, in a community that caters to your every need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Aransas County",
      "seo_description": "Discover Pearl Point's 2 bedroom apartments in Aransas County, offering modern amenities and a prime location for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "3-bedroom-apartments-near-78382",
      "search_query": "3 bedroom apartments near 78382",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 78382",
      "h2_subtitle": "Discover spacious 3 bedroom apartments near 78382 at Pearl Point. Enjoy modern amenities in a welcoming Rockport community.",
      "page_copy": "Experience the luxury of Pearl Point's 3 bedroom apartments located conveniently near the 78382 area. These spacious residences are perfect for growing families or those who simply enjoy extra room, providing ample living space without compromising modern comforts.\n\nNestled in Rockport/North Aransas County, Pearl Point offers more than just a place to live. Our community features upscale amenities, including a well-maintained fitness center, granite countertops, walk-in closets, and a refreshing pool. With a pet-friendly environment, you can bring all members of the family. Choose Pearl Point for a lifestyle of convenience and charm that’s just minutes away from local attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 78382",
      "seo_description": "Explore Pearl Point's 3 bedroom apartments near 78382 with spacious layouts and modern amenities for a comfortable living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "apartments-near-little-bay-primary-rockport",
      "search_query": "apartments near Little Bay Primary Rockport",
      "category": "School",
      "h1_title": "Apartments Near Little Bay Primary",
      "h2_subtitle": "Discover convenient living with apartments near Little Bay Primary in Rockport. Enjoy modern comforts and a welcoming community.",
      "page_copy": "Discover the ease of living close to top education facilities with Pearl Point's apartments near Little Bay Primary in Rockport. Our community offers an ideal location for families seeking accessibility combined with the comforts of modern living. Each apartment is designed with style and functionality in mind, featuring amenities like granite countertops and walk-in closets.\n\nLocated in the welcoming Rockport/North Aransas County area, Pearl Point provides more than just proximity to Little Bay Primary. Our residents enjoy a host of amenities, including a fitness center, swimming pool, and pet-friendly spaces, ensuring convenience and enjoyment for every family member. Embrace a lifestyle that combines comfort with accessibility at Pearl Point.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Little Bay Primary Rockport",
      "seo_description": "Live near Little Bay Primary in Rockport at Pearl Point. Enjoy spacious layouts and modern amenities in a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "rental-homes-close-to-live-oak-learning-center",
      "search_query": "rental homes close to Live Oak Learning Center Rockport TX",
      "category": "School",
      "h1_title": "Rental Homes Close to Live Oak Learning Center",
      "h2_subtitle": "Find the perfect rental homes close to Live Oak Learning Center in Rockport, TX. Enjoy a family-friendly community with modern amenities.",
      "page_copy": "Find your ideal home at Pearl Point, offering rental homes perfectly situated close to Live Oak Learning Center in Rockport, TX. These homes provide a convenient location for families prioritizing education, along with luxurious features like modern kitchens and spacious living environments.\n\nLocated in the charming Rockport/North Aransas County area, our community goes beyond providing rental homes. Residents can take advantage of our state-of-the-art fitness center, engaging recreational spaces including a pool, and pet-friendly facilities. With everything you need at your doorstep, Pearl Point offers a fulfilling lifestyle in a close-knit community ideal for families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Live Oak Learning Center Rockport",
      "seo_description": "Discover rental homes near Live Oak Learning Center in Rockport, TX. Enjoy family-friendly living with modern amenities at Pearl Point.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "rockport-apartments-near-rockport-fulton-middle-school",
      "search_query": "rockport apartments near Rockport-Fulton Middle School",
      "category": "School",
      "h1_title": "Rockport Apartments Near Middle School",
      "h2_subtitle": "Explore Rockport apartments near Rockport-Fulton Middle School. Live in a stylish community with modern amenities perfect for families.",
      "page_copy": "Located a short distance from Rockport-Fulton Middle School, Pearl Point offers ideal Rockport apartments for families prioritizing education and convenience. With a choice of one, two, or three-bedroom floor plans, experience comfortable living without compromising style or modern features.\n\nSituated in the heart of Rockport/North Aransas County, our community boasts impressive amenities, including a fitness center, a sparkling pool, and spaces dedicated to pet enjoyment. Enjoy easy access to local schools while living in a vibrant community designed for family-centric lifestyles at Pearl Point.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rockport Apartments Near Rockport-Fulton Middle School",
      "seo_description": "Find Rockport apartments near Rockport-Fulton Middle School at Pearl Point. Experience modern living with family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "pearson-point-rentals-near-rockport-fulton-high-school",
      "search_query": "pearson point rentals near Rockport-Fulton High School",
      "category": "School",
      "h1_title": "Pearl Point Rentals Near High School",
      "h2_subtitle": "Choose Pearl Point rentals conveniently located near Rockport-Fulton High School. Enjoy community living with upscale amenities.",
      "page_copy": "Pearl Point offers exceptional rentals located just a stone’s throw away from Rockport-Fulton High School, making it an ideal choice for families seeking a convenient lifestyle without compromising on quality. Our spacious rentals are designed for comfortable living with features like modern kitchens and ample storage space through walk-in closets.\n\nNestled within the Rockport/North Aransas County region, Pearl Point is a vibrant community that boasts luxurious amenities including a fitness center, pet-friendly areas, and a gleaming pool. These rentals provide all the essentials for a cohesive, family-friendly living experience with the added benefit of proximity to local educational institutions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pearl Point Rentals Near Rockport-Fulton High School",
      "seo_description": "Experience luxury at Pearl Point rentals near Rockport-Fulton High School. Enjoy upscale living and convenient access to education.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "apartments-near-memorial-park-rockport-tx",
      "search_query": "apartments near Memorial Park Rockport TX",
      "category": "Park",
      "h1_title": "Apartments Near Memorial Park, Rockport, TX",
      "h2_subtitle": "Discover apartments near Memorial Park in Rockport, TX. Experience park-side living with modern amenities and a welcoming community.",
      "page_copy": "Pearl Point is your gateway to comfortable living in Rockport, offering prime apartments located near Memorial Park. Perfectly situated for those who love outdoor activities, these apartments provide easy access to the park’s scenic beauty and recreational opportunities, enhancing your lifestyle with nature at your doorstep.\n\nOur community, nestled in the Rockport/North Aransas County area, features well-appointed one, two, and three-bedroom apartments. Enjoy modern conveniences like granite countertops, walk-in closets, and ceiling fans, along with community amenities such as a fitness center, pool, and pet-friendly spaces. Pearl Point offers a unique blend of location, luxury, and leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Park in Rockport, TX",
      "seo_description": "Find your new home at Pearl Point, offering apartments near Memorial Park in Rockport, TX. Enjoy modern amenities and scenic park views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "apartments-close-to-rockport-beach-park",
      "search_query": "apartments close to Rockport Beach Park",
      "category": "Park",
      "h1_title": "Apartments Close to Rockport Beach Park",
      "h2_subtitle": "Live in apartments close to Rockport Beach Park. Enjoy beachfront access and luxurious living at Pearl Point.",
      "page_copy": "Embrace coastal living at Pearl Point, where our apartments are conveniently close to Rockport Beach Park. Imagine waking up just moments from the serene beachfront, allowing for spontaneous outings to bask in the sun or enjoy the tranquil waves. Our location ensures you’re always near outdoor fun and relaxation.\n\nSituated within the vibrant Rockport/North Aransas County area, our community offers a variety of modern floor plans designed for comfort and style. With amenities like a sparkling pool, fitness center, and pet-friendly areas, Pearl Point provides everything you need for a balanced lifestyle. Relish the unique opportunity to enjoy both beach proximity and upscale apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Rockport Beach Park",
      "seo_description": "Discover Pearl Point apartments close to Rockport Beach Park. Enjoy luxurious living with beachfront access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "find-apartments-by-goose-island-state-park",
      "search_query": "find apartments by Goose Island State Park",
      "category": "Park",
      "h1_title": "Find Apartments by Goose Island State Park",
      "h2_subtitle": "Explore apartments by Goose Island State Park. Enjoy a tranquil lifestyle with nature and modern conveniences at your fingertips.",
      "page_copy": "Located near the tranquil setting of Goose Island State Park, Pearl Point offers the perfect apartments for those seeking both adventure and relaxation. These residences provide a unique opportunity to immerse yourself in nature while enjoying the modern luxuries and conveniences Pearl Point has to offer.\n\nOur community, nestled in the scenic Rockport/North Aransas County, features thoughtfully designed floor plans with amenities like granite countertops, spacious walk-in closets, and ceiling fans. Beyond your doorstep, enjoy a fitness center and a relaxing pool, making Pearl Point an ideal blend of serene nature and contemporary living. Discover your ideal home by Goose Island and indulge in the best of both worlds.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments by Goose Island State Park",
      "seo_description": "Discover Pearl Point apartments by Goose Island State Park. Enjoy serene nature and modern conveniences right at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "pearl-point-near-compass-rose-park",
      "search_query": "Pearl Point near Compass Rose Park",
      "category": "Park",
      "h1_title": "Pearl Point near Compass Rose Park",
      "h2_subtitle": "Discover Pearl Point Apartments near the beautiful Compass Rose Park. Enjoy modern living in a park-side locale within Rockport.",
      "page_copy": "Discover Pearl Point, ideally located near the scenic Compass Rose Park in Rockport, TX. This prime location offers residents the tranquility of park-side living while being enveloped in lush landscapes and vibrant local culture. Enjoy all that this delightful area has to offer with easy access to outdoor adventures and peaceful retreats.\n\nPearl Point features modern one, two, and three-bedroom apartments equipped with upscale amenities like granite countertops, walk-in closets, and ceiling fans. Our community fosters a lifestyle of comfort and convenience, complete with a fitness center, inviting pool, and pet-friendly spaces. Embrace the park-side lifestyle while enjoying all the benefits of contemporary apartment living at Pearl Point.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pearl Point Near Compass Rose Park",
      "seo_description": "Experience Pearl Point near Compass Rose Park in Rockport, TX. Enjoy modern amenities and a vibrant, park-side community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "residences-near-zachary-taylor-arboretum-park",
      "search_query": "residences near Zachary Taylor Arboretum Park Aransas County",
      "category": "Park",
      "h1_title": "Residences Near Zachary Taylor Arboretum",
      "h2_subtitle": "Explore residences near Zachary Taylor Arboretum Park. Embrace nature-rich living in Aransas County at Pearl Point.",
      "page_copy": "Pearl Point offers exquisite residences near the lush landscapes of Zachary Taylor Arboretum Park in Aransas County. This premier location provides the ideal backdrop for those wanting to escape into nature without sacrificing modern comforts. Enjoy the serenity and beauty of the arboretum, just moments from your doorstep.\n\nOur community boasts spacious one, two, and three-bedroom floor plans, designed with thoughtful features such as walk-in closets, sleek granite countertops, and energy-efficient ceiling fans. With amenities that include a well-equipped fitness center and a sparkling pool, Pearl Point seamlessly blends outdoor adventure with stylish, modern apartment living. Discover the perfect blend of natural beauty and contemporary conveniences today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Zachary Taylor Arboretum",
      "seo_description": "Discover Pearl Point residences near Zachary Taylor Arboretum in Aransas County. Enjoy modern living and nature-rich surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191761",
      "source": "custom",
      "page_item_url": "apartments-near-corpus-christi-airport-rockport",
      "search_query": "apartments near corpus christi international airport rockport",
      "category": "Transit",
      "h1_title": "Apartments Near Corpus Christi Airport",
      "h2_subtitle": "Find apartments near Corpus Christi International Airport in Rockport. Enjoy accessible living at Pearl Point.",
      "page_copy": "Pearl Point offers conveniently located apartments near Corpus Christi International Airport, perfect for frequent travelers seeking a comfortable, stylish home base in Rockport. This prime location facilitates easy airport access while providing a peaceful retreat from the hustle and bustle.\n\nChoose from our selection of spacious one, two, and three-bedroom residences with features such as granite countertops, walk-in closets, and ceiling fans. Our community amenities include a fitness center and a refreshing pool, providing a perfect blend of relaxation and activity. Experience the ideal combination of convenience and comfort at Pearl Point, nestled in the charm of Rockport, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
      "featured_image_media": {
        "alt_text": "Covered outdoor lounge area with colorful striped seating and view of pool and apartment buildings.",
        "public_id": "019d076f-4289-7789-9135-f323c9d496cd",
        "storage_key": "property/6737460151191761/019d076f-4289-7789-9135-f323c9d496cd.webp",
        "width": 2048,
        "height": 1336
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Corpus Christi Airport",
      "seo_description": "Pearl Point in Rockport offers apartments near Corpus Christi International Airport. Enjoy comfortable, convenient living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3341"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5025330672"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5007362"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TKGZFXML"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "361-282-1208"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "361-418-8315"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "361-301-2516"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "361-314-2716"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "361-301-8855"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "361-266-4470"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "361-273-9785"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "361-314-2660"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "361-310-0991"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "361-282-1928"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "361-264-4157"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "361-437-4049"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "361-282-6122"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "361-326-2215"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "361-326-3049"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "361-202-9496"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "361-314-2839"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "361-273-3250"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "361-320-6436"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "16832574881"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "361-353-7728"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "361-322-1152"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1015ff11eee435b7"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "361-310-7507"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "361-266-7762"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "361-273-8632"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "361-675-8965"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "361-418-8341"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "361-204-4896"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "361-301-1882"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.livepearlpoint.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191761/019e6484-145b-709a-9289-26e826268653.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "361-301-2415"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "361-264-4157"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3341",
  "custom_repli_id": "5025330672",
  "custom_realpage_id": "5007362",
  "custom_knock_a_link": "https://www.livepearlpoint.com?utm_knock=a",
  "custom_knock_g_link": "https://www.livepearlpoint.com?utm_knock=g",
  "custom_knock_r_link": "https://www.livepearlpoint.com?utm_knock=r",
  "custom_knock_w_link": "https://www.livepearlpoint.com?utm_knock=w",
  "custom_knock_z_link": "https://www.livepearlpoint.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-TKGZFXML",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.livepearlpoint.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.livepearlpoint.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.livepearlpoint.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.livepearlpoint.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.livepearlpoint.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.livepearlpoint.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "361-282-1208",
  "custom_knock_ads_link": "https://www.livepearlpoint.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.livepearlpoint.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "361-418-8315",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.livepearlpoint.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.livepearlpoint.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.livepearlpoint.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.livepearlpoint.com?utm_knock=psa",
  "custom_knock_r_number": "361-301-2516",
  "custom_knock_w_number": "361-314-2716",
  "custom_knock_z_number": "361-301-8855",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "361-266-4470",
  "custom_knock_amap_link": "https://www.livepearlpoint.com?utm_knock=amap",
  "custom_knock_ar_number": "361-273-9785",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "361-314-2660",
  "custom_knock_fb_number": "361-310-0991",
  "custom_knock_fl_number": "361-282-1928",
  "custom_knock_gp_number": "361-264-4157",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.livepearlpoint.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "361-437-4049",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.livepearlpoint.com?utm_knock=bcard",
  "custom_knock_bnr_number": "361-282-6122",
  "custom_knock_cfres_link": "https://www.livepearlpoint.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "361-326-2215",
  "custom_knock_lgp_number": "361-326-3049",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.livepearlpoint.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "361-202-9496",
  "custom_knock_psa_number": "361-314-2839",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "361-273-3250",
  "custom_knock_bandit_link": "https://www.livepearlpoint.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.livepearlpoint.com?utm_knock=flyers",
  "custom_knock_osoc_number": "361-320-6436",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "16832574881",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "361-353-7728",
  "custom_knock_cfres_number": "361-322-1152",
  "custom_knock_chatgpt_link": "https://www.livepearlpoint.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1015ff11eee435b7",
  "custom_knock_dirmail_link": "https://www.livepearlpoint.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "361-310-7507",
  "custom_knock_propbro_link": "https://www.livepearlpoint.com?utm_knock=propbro",
  "custom_knock_bandit_number": "361-266-7762",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "361-273-8632",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.livepearlpoint.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "361-675-8965",
  "custom_knock_dirmail_number": "361-418-8341",
  "custom_knock_propbro_number": "361-204-4896",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "361-301-1882",
  "custom_knock_maintenance_link": "https://www.livepearlpoint.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191761/019e6484-145b-709a-9289-26e826268653.mp4",
  "custom_knock_maintenance_number": "361-301-2415",
  "custom_ppc_tracking_phone_number": "361-264-4157"
};

export const generatedAt = '2026-10-07T17:15:47.737Z';
